// DO NOT EDIT MANUALLY
// This file was auto-generated by the generate-index script.
// To regenerate, run this command from clients/web: `npm run generate:icons`
//
// Last generated: 9/18/2026, 11:46:50 AM

/* eslint-disable */

import ActionsIcon from './hypernova/icons/actions.svg'
import ActionsXlIcon from './hypernova/icons/actions-xl.svg'
import ActivityIcon from './hypernova/icons/activity.svg'
import AdminCogsIcon from './hypernova/icons/admin-cogs.svg'
import AlertIcon from './hypernova/icons/alert.svg'
import AnnotateIcon from './hypernova/icons/annotate.svg'
import AnnouncementIcon from './hypernova/icons/announcement.svg'
import AppPeopleIcon from './hypernova/icons/app-people.svg'
import AppPresentationsIcon from './hypernova/icons/app-presentations.svg'
import AppWorkspacesIcon from './hypernova/icons/app-workspaces.svg'
import ApprovalIcon from './hypernova/icons/approval.svg'
import ApprovalPauseIcon from './hypernova/icons/approval-pause.svg'
import ApproveWithCommentIcon from './hypernova/icons/approve-with-comment.svg'
import ArrowEIcon from './hypernova/icons/arrow-e.svg'
import ArrowNIcon from './hypernova/icons/arrow-n.svg'
import ArrowNsIcon from './hypernova/icons/arrow-ns.svg'
import ArrowSIcon from './hypernova/icons/arrow-s.svg'
import ArrowWIcon from './hypernova/icons/arrow-w.svg'
import AssetLibraryIcon from './hypernova/icons/asset-library.svg'
import AssetsIcon from './hypernova/icons/assets.svg'
import AssignmentsEmptyIcon from './hypernova/icons/assignments-empty.svg'
import BarGraphIcon from './hypernova/icons/bar-graph.svg'
import BriefIcon from './hypernova/icons/brief.svg'
import BrowseIcon from './hypernova/icons/browse.svg'
import BsApprovalsIcon from './hypernova/icons/bs-approvals.svg'
import BsAssignmentsIcon from './hypernova/icons/bs-assignments.svg'
import BsConfigureIcon from './hypernova/icons/bs-configure.svg'
import BsContentQueueIcon from './hypernova/icons/bs-content-queue.svg'
import BsMomentsIcon from './hypernova/icons/bs-moments.svg'
import BsPausedQueueIcon from './hypernova/icons/bs-paused-queue.svg'
import BsStoriesIcon from './hypernova/icons/bs-stories.svg'
import BsTimelineIcon from './hypernova/icons/bs-timeline.svg'
import BsTimelinesIcon from './hypernova/icons/bs-timelines.svg'
import BsWorkspaceDirectoryIcon from './hypernova/icons/bs-workspace-directory.svg'
import BudgetMIcon from './hypernova/icons/budget-m.svg'
import CalendarIcon from './hypernova/icons/calendar.svg'
import CardIcon from './hypernova/icons/card.svg'
import CardlessIcon from './hypernova/icons/cardless.svg'
import ChannelAdIcon from './hypernova/icons/channel-ad.svg'
import ChannelAd14Icon from './hypernova/icons/channel-ad-14.svg'
import ChannelAdSmIcon from './hypernova/icons/channel-ad-sm.svg'
import ChannelAllIcon from './hypernova/icons/channel-all.svg'
import ChannelAll14Icon from './hypernova/icons/channel-all-14.svg'
import ChannelAllSmIcon from './hypernova/icons/channel-all-sm.svg'
import ChannelAudioIcon from './hypernova/icons/channel-audio.svg'
import ChannelAudio14Icon from './hypernova/icons/channel-audio-14.svg'
import ChannelAudioSmIcon from './hypernova/icons/channel-audio-sm.svg'
import ChannelBlogIcon from './hypernova/icons/channel-blog.svg'
import ChannelBlog14Icon from './hypernova/icons/channel-blog-14.svg'
import ChannelBlogSmIcon from './hypernova/icons/channel-blog-sm.svg'
import ChannelBlueskyIcon from './hypernova/icons/channel-bluesky.svg'
import ChannelBluesky14Icon from './hypernova/icons/channel-bluesky-14.svg'
import ChannelBlueskySmIcon from './hypernova/icons/channel-bluesky-sm.svg'
import ChannelCalendarIcon from './hypernova/icons/channel-calendar.svg'
import ChannelCalendar14Icon from './hypernova/icons/channel-calendar-14.svg'
import ChannelCalendarSmIcon from './hypernova/icons/channel-calendar-sm.svg'
import ChannelDisplayAdIcon from './hypernova/icons/channel-display-ad.svg'
import ChannelDisplayAd14Icon from './hypernova/icons/channel-display-ad-14.svg'
import ChannelDisplayAdSmIcon from './hypernova/icons/channel-display-ad-sm.svg'
import ChannelEmailIcon from './hypernova/icons/channel-email.svg'
import ChannelEmail14Icon from './hypernova/icons/channel-email-14.svg'
import ChannelEmailSmIcon from './hypernova/icons/channel-email-sm.svg'
import ChannelFacebookIcon from './hypernova/icons/channel-facebook.svg'
import ChannelFacebook14Icon from './hypernova/icons/channel-facebook-14.svg'
import ChannelFacebookSmIcon from './hypernova/icons/channel-facebook-sm.svg'
import ChannelFlickrIcon from './hypernova/icons/channel-flickr.svg'
import ChannelFlickr14Icon from './hypernova/icons/channel-flickr-14.svg'
import ChannelFlickrSmIcon from './hypernova/icons/channel-flickr-sm.svg'
import ChannelFoursquareIcon from './hypernova/icons/channel-foursquare.svg'
import ChannelFoursquare14Icon from './hypernova/icons/channel-foursquare-14.svg'
import ChannelFoursquareSmIcon from './hypernova/icons/channel-foursquare-sm.svg'
import ChannelGoogleplusIcon from './hypernova/icons/channel-googleplus.svg'
import ChannelGoogleplus14Icon from './hypernova/icons/channel-googleplus-14.svg'
import ChannelGoogleplusSmIcon from './hypernova/icons/channel-googleplus-sm.svg'
import ChannelInstagramIcon from './hypernova/icons/channel-instagram.svg'
import ChannelInstagram14Icon from './hypernova/icons/channel-instagram-14.svg'
import ChannelInstagramSmIcon from './hypernova/icons/channel-instagram-sm.svg'
import ChannelLinkedinIcon from './hypernova/icons/channel-linkedin.svg'
import ChannelLinkedin14Icon from './hypernova/icons/channel-linkedin-14.svg'
import ChannelLinkedinSmIcon from './hypernova/icons/channel-linkedin-sm.svg'
import ChannelListIcon from './hypernova/icons/channel-list.svg'
import ChannelList14Icon from './hypernova/icons/channel-list-14.svg'
import ChannelListSmIcon from './hypernova/icons/channel-list-sm.svg'
import ChannelMailIcon from './hypernova/icons/channel-mail.svg'
import ChannelMail14Icon from './hypernova/icons/channel-mail-14.svg'
import ChannelMailSmIcon from './hypernova/icons/channel-mail-sm.svg'
import ChannelMessageIcon from './hypernova/icons/channel-message.svg'
import ChannelMessage14Icon from './hypernova/icons/channel-message-14.svg'
import ChannelMessageSmIcon from './hypernova/icons/channel-message-sm.svg'
import ChannelMoreIcon from './hypernova/icons/channel-more.svg'
import ChannelMore14Icon from './hypernova/icons/channel-more-14.svg'
import ChannelMoreSmIcon from './hypernova/icons/channel-more-sm.svg'
import ChannelNikeIcon from './hypernova/icons/channel-nike.svg'
import ChannelNike14Icon from './hypernova/icons/channel-nike-14.svg'
import ChannelNikeSmIcon from './hypernova/icons/channel-nike-sm.svg'
import ChannelPhotoIcon from './hypernova/icons/channel-photo.svg'
import ChannelPhoto14Icon from './hypernova/icons/channel-photo-14.svg'
import ChannelPhotoSmIcon from './hypernova/icons/channel-photo-sm.svg'
import ChannelPinterestIcon from './hypernova/icons/channel-pinterest.svg'
import ChannelPinterest14Icon from './hypernova/icons/channel-pinterest-14.svg'
import ChannelPinterestSmIcon from './hypernova/icons/channel-pinterest-sm.svg'
import ChannelPrintIcon from './hypernova/icons/channel-print.svg'
import ChannelPrint14Icon from './hypernova/icons/channel-print-14.svg'
import ChannelPrintSmIcon from './hypernova/icons/channel-print-sm.svg'
import ChannelRedditIcon from './hypernova/icons/channel-reddit.svg'
import ChannelReddit14Icon from './hypernova/icons/channel-reddit-14.svg'
import ChannelRedditSmIcon from './hypernova/icons/channel-reddit-sm.svg'
import ChannelSmsIcon from './hypernova/icons/channel-sms.svg'
import ChannelSms14Icon from './hypernova/icons/channel-sms-14.svg'
import ChannelSmsSmIcon from './hypernova/icons/channel-sms-sm.svg'
import ChannelSnapchatIcon from './hypernova/icons/channel-snapchat.svg'
import ChannelSnapchat14Icon from './hypernova/icons/channel-snapchat-14.svg'
import ChannelSnapchatSmIcon from './hypernova/icons/channel-snapchat-sm.svg'
import ChannelStarIcon from './hypernova/icons/channel-star.svg'
import ChannelStar14Icon from './hypernova/icons/channel-star-14.svg'
import ChannelStarSmIcon from './hypernova/icons/channel-star-sm.svg'
import ChannelThreadsIcon from './hypernova/icons/channel-threads.svg'
import ChannelThreads14Icon from './hypernova/icons/channel-threads-14.svg'
import ChannelThreadsSmIcon from './hypernova/icons/channel-threads-sm.svg'
import ChannelTiktokIcon from './hypernova/icons/channel-tiktok.svg'
import ChannelTiktok14Icon from './hypernova/icons/channel-tiktok-14.svg'
import ChannelTiktokSmIcon from './hypernova/icons/channel-tiktok-sm.svg'
import ChannelTumblrIcon from './hypernova/icons/channel-tumblr.svg'
import ChannelTumblr14Icon from './hypernova/icons/channel-tumblr-14.svg'
import ChannelTumblrSmIcon from './hypernova/icons/channel-tumblr-sm.svg'
import ChannelTwitterIcon from './hypernova/icons/channel-twitter.svg'
import ChannelTwitter14Icon from './hypernova/icons/channel-twitter-14.svg'
import ChannelTwitterSmIcon from './hypernova/icons/channel-twitter-sm.svg'
import ChannelVideoIcon from './hypernova/icons/channel-video.svg'
import ChannelVideo14Icon from './hypernova/icons/channel-video-14.svg'
import ChannelVideoSmIcon from './hypernova/icons/channel-video-sm.svg'
import ChannelVimeoIcon from './hypernova/icons/channel-vimeo.svg'
import ChannelVimeo14Icon from './hypernova/icons/channel-vimeo-14.svg'
import ChannelVimeoSmIcon from './hypernova/icons/channel-vimeo-sm.svg'
import ChannelVineIcon from './hypernova/icons/channel-vine.svg'
import ChannelVine14Icon from './hypernova/icons/channel-vine-14.svg'
import ChannelVineSmIcon from './hypernova/icons/channel-vine-sm.svg'
import ChannelVkIcon from './hypernova/icons/channel-vk.svg'
import ChannelVk14Icon from './hypernova/icons/channel-vk-14.svg'
import ChannelVkSmIcon from './hypernova/icons/channel-vk-sm.svg'
import ChannelWebModulesIcon from './hypernova/icons/channel-web-modules.svg'
import ChannelWebModules14Icon from './hypernova/icons/channel-web-modules-14.svg'
import ChannelWebModulesSmIcon from './hypernova/icons/channel-web-modules-sm.svg'
import ChannelWebsiteIcon from './hypernova/icons/channel-website.svg'
import ChannelWebsite14Icon from './hypernova/icons/channel-website-14.svg'
import ChannelWebsiteSmIcon from './hypernova/icons/channel-website-sm.svg'
import ChannelWeiboIcon from './hypernova/icons/channel-weibo.svg'
import ChannelWeibo14Icon from './hypernova/icons/channel-weibo-14.svg'
import ChannelWeiboSmIcon from './hypernova/icons/channel-weibo-sm.svg'
import ChannelWordpressIcon from './hypernova/icons/channel-wordpress.svg'
import ChannelWordpress14Icon from './hypernova/icons/channel-wordpress-14.svg'
import ChannelWordpressSmIcon from './hypernova/icons/channel-wordpress-sm.svg'
import ChannelYoutubeIcon from './hypernova/icons/channel-youtube.svg'
import ChannelYoutube14Icon from './hypernova/icons/channel-youtube-14.svg'
import ChannelYoutubeSmIcon from './hypernova/icons/channel-youtube-sm.svg'
import ChannelsSmsIcon from './hypernova/icons/channels-sms.svg'
import ChatActivityIcon from './hypernova/icons/chat-activity.svg'
import CheckInIcon from './hypernova/icons/check-in.svg'
import CheckOutIcon from './hypernova/icons/check-out.svg'
import CheckOutDisabledIcon from './hypernova/icons/check-out-disabled.svg'
import CheckmarkIcon from './hypernova/icons/checkmark.svg'
import CheckmarkCopy6Icon from './hypernova/icons/checkmark copy 6.svg'
import CheckmarkSmIcon from './hypernova/icons/checkmark-sm.svg'
import ChevronColorIcon from './hypernova/icons/chevron-color.svg'
import ChevronEIcon from './hypernova/icons/chevron-e.svg'
import ChevronLgEIcon from './hypernova/icons/chevron-lg-e.svg'
import ChevronLgNIcon from './hypernova/icons/chevron-lg-n.svg'
import ChevronLgSIcon from './hypernova/icons/chevron-lg-s.svg'
import ChevronLgWIcon from './hypernova/icons/chevron-lg-w.svg'
import ChevronNIcon from './hypernova/icons/chevron-n.svg'
import ChevronSIcon from './hypernova/icons/chevron-s.svg'
import ChevronWIcon from './hypernova/icons/chevron-w.svg'
import CircleIcon from './hypernova/icons/circle.svg'
import ClockIcon from './hypernova/icons/clock.svg'
import CloseCircleIcon from './hypernova/icons/close-circle.svg'
import CloseLgIcon from './hypernova/icons/close-lg.svg'
import CloseSmIcon from './hypernova/icons/close-sm.svg'
import CogLgIcon from './hypernova/icons/cog-lg.svg'
import CogSmIcon from './hypernova/icons/cog-sm.svg'
import CogXlIcon from './hypernova/icons/cog-xl.svg'
import CollapseIcon from './hypernova/icons/collapse.svg'
import CommentEmptyIcon from './hypernova/icons/comment-empty.svg'
import CommentFilledIcon from './hypernova/icons/comment-filled.svg'
import ContentIcon from './hypernova/icons/content.svg'
import ContentCutoutIcon from './hypernova/icons/content-cutout.svg'
import ContentDeliveryIcon from './hypernova/icons/content-delivery.svg'
import ContentHoldIcon from './hypernova/icons/content-hold.svg'
import CoverImageIcon from './hypernova/icons/cover-image.svg'
import CreateIcon from './hypernova/icons/create.svg'
import CrosshairIcon from './hypernova/icons/crosshair.svg'
import CsvExportIcon from './hypernova/icons/csv-export.svg'
import CsvExportIlloIcon from './hypernova/icons/csv-export-illo.svg'
import DeclineIcon from './hypernova/icons/decline.svg'
import DeleteIcon from './hypernova/icons/delete.svg'
import DesktopIcon from './hypernova/icons/desktop.svg'
import DonutChartIcon from './hypernova/icons/donut-chart.svg'
import DownloadIcon from './hypernova/icons/download.svg'
import DrawerCloseIcon from './hypernova/icons/drawer-close.svg'
import DrawerOpenIcon from './hypernova/icons/drawer-open.svg'
import DropArrowIcon from './hypernova/icons/drop-arrow.svg'
import DropArrowPlusIcon from './hypernova/icons/drop-arrow-plus.svg'
import DuplicateContentIcon from './hypernova/icons/duplicate-content.svg'
import EditIcon from './hypernova/icons/edit.svg'
import EllipsisIcon from './hypernova/icons/ellipsis.svg'
import EmojiInChatIcon from './hypernova/icons/emoji-in-chat.svg'
import EnterIcon from './hypernova/icons/enter.svg'
import EscIcon from './hypernova/icons/esc.svg'
import ExpandIcon from './hypernova/icons/expand.svg'
import EyeIcon from './hypernova/icons/eye.svg'
import EyeHiddenIcon from './hypernova/icons/eye-hidden.svg'
import FacebookDesktopAdLikeIcon from './hypernova/icons/facebook-desktop-ad-like.svg'
import FacebookDesktopArrowIcon from './hypernova/icons/facebook-desktop-arrow.svg'
import FacebookDesktopFollowIcon from './hypernova/icons/facebook-desktop-follow.svg'
import FacebookDesktopGlobeIcon from './hypernova/icons/facebook-desktop-globe.svg'
import FacebookDesktopLikeIcon from './hypernova/icons/facebook-desktop-like.svg'
import FacebookDesktopLikeOutlinedIcon from './hypernova/icons/facebook-desktop-like-outlined.svg'
import FacebookDesktopMessageIcon from './hypernova/icons/facebook-desktop-message.svg'
import FacebookDesktopMessageOutlinedIcon from './hypernova/icons/facebook-desktop-message-outlined.svg'
import FacebookDesktopMoreIcon from './hypernova/icons/facebook-desktop-more.svg'
import FacebookDesktopPrivacyFofIcon from './hypernova/icons/facebook-desktop-privacy-fof.svg'
import FacebookDesktopShareIcon from './hypernova/icons/facebook-desktop-share.svg'
import FacebookDesktopShareOutlinedIcon from './hypernova/icons/facebook-desktop-share-outlined.svg'
import FacebookMobileCanvasChevronUpIcon from './hypernova/icons/facebook-mobile-canvas-chevron-up.svg'
import FacebookMobileCommentIcon from './hypernova/icons/facebook-mobile-comment.svg'
import FacebookMobileCommentOutlinedIcon from './hypernova/icons/facebook-mobile-comment-outlined.svg'
import FacebookMobileEventAdRsvpIcon from './hypernova/icons/facebook-mobile-event-ad-rsvp.svg'
import FacebookMobileGlobeIcon from './hypernova/icons/facebook-mobile-globe.svg'
import FacebookMobileLikeIcon from './hypernova/icons/facebook-mobile-like.svg'
import FacebookMobileLikeOutlinedIcon from './hypernova/icons/facebook-mobile-like-outlined.svg'
import FacebookMobilePrivacyFofIcon from './hypernova/icons/facebook-mobile-privacy-fof.svg'
import FacebookMobileReelCameraIcon from './hypernova/icons/facebook-mobile-reel-camera.svg'
import FacebookMobileReelChevronDownIcon from './hypernova/icons/facebook-mobile-reel-chevron-down.svg'
import FacebookMobileReelChevronLeftIcon from './hypernova/icons/facebook-mobile-reel-chevron-left.svg'
import FacebookMobileReelLocationIcon from './hypernova/icons/facebook-mobile-reel-location.svg'
import FacebookMobileReelSearchIcon from './hypernova/icons/facebook-mobile-reel-search.svg'
import FacebookMobileReelSoundIcon from './hypernova/icons/facebook-mobile-reel-sound.svg'
import FacebookMobileReelUserIcon from './hypernova/icons/facebook-mobile-reel-user.svg'
import FacebookMobileShareIcon from './hypernova/icons/facebook-mobile-share.svg'
import FacebookMobileShareOutlinedIcon from './hypernova/icons/facebook-mobile-share-outlined.svg'
import FacebookMobileStoryChevronUpIcon from './hypernova/icons/facebook-mobile-story-chevron-up.svg'
import FacebookMobileStoryLikeIcon from './hypernova/icons/facebook-mobile-story-like.svg'
import FacebookMobileStoryMoreIcon from './hypernova/icons/facebook-mobile-story-more.svg'
import FacebookMobileStoryShareIcon from './hypernova/icons/facebook-mobile-story-share.svg'
import FacebookMobileStorySocialLaughIcon from './hypernova/icons/facebook-mobile-story-social-laugh.svg'
import FacebookMobileStorySocialLikeIcon from './hypernova/icons/facebook-mobile-story-social-like.svg'
import FacebookMobileStorySocialLoveIcon from './hypernova/icons/facebook-mobile-story-social-love.svg'
import FacebookMobileTiltToPanIcon from './hypernova/icons/facebook-mobile-tilt-to-pan.svg'
import FacebookMobileVideoAdLikeIcon from './hypernova/icons/facebook-mobile-video-ad-like.svg'
import FileIcon from './hypernova/icons/file.svg'
import FolderDirectoryIcon from './hypernova/icons/folder-directory.svg'
import GoogleDesktopChevronIcon from './hypernova/icons/google-desktop-chevron.svg'
import GoogleDesktopDateIcon from './hypernova/icons/google-desktop-date.svg'
import GoogleDesktopDropdownArrowIcon from './hypernova/icons/google-desktop-dropdown-arrow.svg'
import GoogleDesktopHangoutIcon from './hypernova/icons/google-desktop-hangout.svg'
import GoogleDesktopPersonIcon from './hypernova/icons/google-desktop-person.svg'
import GoogleDesktopPlaceIcon from './hypernova/icons/google-desktop-place.svg'
import GoogleDesktopPlayIcon from './hypernova/icons/google-desktop-play.svg'
import GoogleDesktopPlusIcon from './hypernova/icons/google-desktop-plus.svg'
import GoogleDesktopShareIcon from './hypernova/icons/google-desktop-share.svg'
import GoogleMobileCommentIcon from './hypernova/icons/google-mobile-comment.svg'
import GoogleMobileEventClockIcon from './hypernova/icons/google-mobile-event-clock.svg'
import GoogleMobileEventPeopleIcon from './hypernova/icons/google-mobile-event-people.svg'
import GoogleMobileEventPlaceIcon from './hypernova/icons/google-mobile-event-place.svg'
import GoogleMobileHangoutIcon from './hypernova/icons/google-mobile-hangout.svg'
import GoogleMobilePlayIcon from './hypernova/icons/google-mobile-play.svg'
import GoogleMobilePlusIcon from './hypernova/icons/google-mobile-plus.svg'
import GoogleMobileShareIcon from './hypernova/icons/google-mobile-share.svg'
import GrabberNsIcon from './hypernova/icons/grabber-ns.svg'
import GrabberNsLgIcon from './hypernova/icons/grabber-ns-lg.svg'
import GrabberNsewIcon from './hypernova/icons/grabber-nsew.svg'
import ImageIgtvVideoControlsIcon from './hypernova/icons/image-igtv-video-controls.svg'
import ImageIlloIcon from './hypernova/icons/image-illo.svg'
import InfoIcon from './hypernova/icons/info.svg'
import InstagramDesktopHeartIcon from './hypernova/icons/instagram-desktop-heart.svg'
import InstagramDesktopMoreIcon from './hypernova/icons/instagram-desktop-more.svg'
import InstagramMobileBookmarkIcon from './hypernova/icons/instagram-mobile-bookmark.svg'
import InstagramMobileButtonChevronIcon from './hypernova/icons/instagram-mobile-button-chevron.svg'
import InstagramMobileCameraIcon from './hypernova/icons/instagram-mobile-camera.svg'
import InstagramMobileCameraInvertedIcon from './hypernova/icons/instagram-mobile-camera-inverted.svg'
import InstagramMobileChevronIcon from './hypernova/icons/instagram-mobile-chevron.svg'
import InstagramMobileCloseIcon from './hypernova/icons/instagram-mobile-close.svg'
import InstagramMobileCommentIcon from './hypernova/icons/instagram-mobile-comment.svg'
import InstagramMobileCtaChevronIcon from './hypernova/icons/instagram-mobile-cta-chevron.svg'
import InstagramMobileDiagonalArrowIcon from './hypernova/icons/instagram-mobile-diagonal-arrow.svg'
import InstagramMobileEffectIcon from './hypernova/icons/instagram-mobile-effect.svg'
import InstagramMobileGridIcon from './hypernova/icons/instagram-mobile-grid.svg'
import InstagramMobileHeartIcon from './hypernova/icons/instagram-mobile-heart.svg'
import InstagramMobileIgtvTimerBarIcon from './hypernova/icons/instagram-mobile-igtv-timer-bar.svg'
import InstagramMobileLinkArrowIcon from './hypernova/icons/instagram-mobile-link-arrow.svg'
import InstagramMobileListIcon from './hypernova/icons/instagram-mobile-list.svg'
import InstagramMobileLocationIcon from './hypernova/icons/instagram-mobile-location.svg'
import InstagramMobileMoreIcon from './hypernova/icons/instagram-mobile-more.svg'
import InstagramMobilePlayIcon from './hypernova/icons/instagram-mobile-play.svg'
import InstagramMobilePlayInvertedIcon from './hypernova/icons/instagram-mobile-play-inverted.svg'
import InstagramMobileProfileIgtvIcon from './hypernova/icons/instagram-mobile-profile-igtv.svg'
import InstagramMobileProfilePostsIcon from './hypernova/icons/instagram-mobile-profile-posts.svg'
import InstagramMobileProfileReelIcon from './hypernova/icons/instagram-mobile-profile-reel.svg'
import InstagramMobileProfileTaggedIcon from './hypernova/icons/instagram-mobile-profile-tagged.svg'
import InstagramMobileSendIcon from './hypernova/icons/instagram-mobile-send.svg'
import InstagramMobileSoundIcon from './hypernova/icons/instagram-mobile-sound.svg'
import InstagramMobileSponsoredIcon from './hypernova/icons/instagram-mobile-sponsored.svg'
import InstagramMobileSwipeUpIcon from './hypernova/icons/instagram-mobile-swipe-up.svg'
import InstagramMobileSwipeUpOutlineIcon from './hypernova/icons/instagram-mobile-swipe-up-outline.svg'
import InstagramMobileTaggedIcon from './hypernova/icons/instagram-mobile-tagged.svg'
import IntegrationIcon from './hypernova/icons/integration.svg'
import JumpIcon from './hypernova/icons/jump.svg'
import LabelIcon from './hypernova/icons/label.svg'
import LabelSetIcon from './hypernova/icons/label-set.svg'
import LayoutAssetLgIcon from './hypernova/icons/layout-asset-lg.svg'
import LayoutCtaIcon from './hypernova/icons/layout-cta.svg'
import LayoutCta2Icon from './hypernova/icons/layout-cta-2.svg'
import LayoutCta3Icon from './hypernova/icons/layout-cta-3.svg'
import LayoutDayLgIcon from './hypernova/icons/layout-day-lg.svg'
import LayoutH1Icon from './hypernova/icons/layout-h1.svg'
import LayoutH2Icon from './hypernova/icons/layout-h2.svg'
import LayoutHeroIcon from './hypernova/icons/layout-hero.svg'
import LayoutImageIcon from './hypernova/icons/layout-image.svg'
import LayoutImage2Icon from './hypernova/icons/layout-image-2.svg'
import LayoutImage3Icon from './hypernova/icons/layout-image-3.svg'
import LayoutImageBottomIcon from './hypernova/icons/layout-image-bottom.svg'
import LayoutImageLeftIcon from './hypernova/icons/layout-image-left.svg'
import LayoutImageRightIcon from './hypernova/icons/layout-image-right.svg'
import LayoutImageTextIcon from './hypernova/icons/layout-image-text.svg'
import LayoutImageTopIcon from './hypernova/icons/layout-image-top.svg'
import LayoutMomentIcon from './hypernova/icons/layout-moment.svg'
import LayoutMomentLgIcon from './hypernova/icons/layout-moment-lg.svg'
import LayoutMonthLgIcon from './hypernova/icons/layout-month-lg.svg'
import LayoutSectionHeaderIcon from './hypernova/icons/layout-section-header.svg'
import LayoutTextIcon from './hypernova/icons/layout-text.svg'
import LayoutText2Icon from './hypernova/icons/layout-text-2.svg'
import LayoutText3Icon from './hypernova/icons/layout-text-3.svg'
import LayoutTextCenterIcon from './hypernova/icons/layout-text-center.svg'
import LayoutTextImageIcon from './hypernova/icons/layout-text-image.svg'
import LayoutTextImgLgIcon from './hypernova/icons/layout-text-img-lg.svg'
import LayoutTextLeftIcon from './hypernova/icons/layout-text-left.svg'
import LayoutTextRightIcon from './hypernova/icons/layout-text-right.svg'
import LayoutWeekLgIcon from './hypernova/icons/layout-week-lg.svg'
import LifesaverIcon from './hypernova/icons/lifesaver.svg'
import LinkedinDesktopCommentIcon from './hypernova/icons/linkedin-desktop-comment.svg'
import LinkedinDesktopImmersiveReaderIcon from './hypernova/icons/linkedin-desktop-immersive-reader.svg'
import LinkedinDesktopLikeIcon from './hypernova/icons/linkedin-desktop-like.svg'
import LinkedinDesktopSaveIcon from './hypernova/icons/linkedin-desktop-save.svg'
import LinkedinDesktopShareIcon from './hypernova/icons/linkedin-desktop-share.svg'
import LinkedinMobileCommentIcon from './hypernova/icons/linkedin-mobile-comment.svg'
import LinkedinMobileFollowIcon from './hypernova/icons/linkedin-mobile-follow.svg'
import LinkedinMobileLikeIcon from './hypernova/icons/linkedin-mobile-like.svg'
import LinkedinMobileShareIcon from './hypernova/icons/linkedin-mobile-share.svg'
import LocalizationsIcon from './hypernova/icons/localizations.svg'
import LocationMarkerIcon from './hypernova/icons/location-marker.svg'
import LocationMarkerSmIcon from './hypernova/icons/location-marker-sm.svg'
import LockedIcon from './hypernova/icons/locked.svg'
import LongformBlockquoteIcon from './hypernova/icons/longform-blockquote.svg'
import LongformBoldIcon from './hypernova/icons/longform-bold.svg'
import LongformH1Icon from './hypernova/icons/longform-h1.svg'
import LongformH2Icon from './hypernova/icons/longform-h2.svg'
import LongformH3Icon from './hypernova/icons/longform-h3.svg'
import LongformItalicIcon from './hypernova/icons/longform-italic.svg'
import LongformOlIcon from './hypernova/icons/longform-ol.svg'
import LongformPIcon from './hypernova/icons/longform-p.svg'
import LongformStrikethroughIcon from './hypernova/icons/longform-strikethrough.svg'
import LongformTextIcon from './hypernova/icons/longform-text.svg'
import LongformUlIcon from './hypernova/icons/longform-ul.svg'
import LongformUnderlineIcon from './hypernova/icons/longform-underline.svg'
import MinusIcon from './hypernova/icons/minus.svg'
import MinusSolidIcon from './hypernova/icons/minus-solid.svg'
import MobileIcon from './hypernova/icons/mobile.svg'
import MomentIcon from './hypernova/icons/moment.svg'
import MomentCutoutIcon from './hypernova/icons/moment-cutout.svg'
import MoveIcon from './hypernova/icons/move.svg'
import NoteIcon from './hypernova/icons/note.svg'
import NotificationsIcon from './hypernova/icons/notifications.svg'
import OpalWordmarkIcon from './hypernova/icons/opal-wordmark.svg'
import PdfDigitalIcon from './hypernova/icons/pdf-digital.svg'
import PdfPrintIcon from './hypernova/icons/pdf-print.svg'
import PercentageIcon from './hypernova/icons/percentage.svg'
import PersonIcon from './hypernova/icons/person.svg'
import PersonAddIcon from './hypernova/icons/person-add.svg'
import PersonSmIcon from './hypernova/icons/person-sm.svg'
import PhoneIcon from './hypernova/icons/phone.svg'
import PinterestDesktopArrowNeIcon from './hypernova/icons/pinterest-desktop-arrow-ne.svg'
import PinterestDesktopDownIcon from './hypernova/icons/pinterest-desktop-down.svg'
import PinterestDesktopDropdownIcon from './hypernova/icons/pinterest-desktop-dropdown.svg'
import PinterestDesktopLikeIcon from './hypernova/icons/pinterest-desktop-like.svg'
import PinterestDesktopMoreIcon from './hypernova/icons/pinterest-desktop-more.svg'
import PinterestDesktopReactIcon from './hypernova/icons/pinterest-desktop-react.svg'
import PinterestDesktopSaveIcon from './hypernova/icons/pinterest-desktop-save.svg'
import PinterestDesktopSendIcon from './hypernova/icons/pinterest-desktop-send.svg'
import PinterestDesktopShareIcon from './hypernova/icons/pinterest-desktop-share.svg'
import PinterestDesktopTriedItIcon from './hypernova/icons/pinterest-desktop-tried-it.svg'
import PinterestMobileArrowNeIcon from './hypernova/icons/pinterest-mobile-arrow-ne.svg'
import PinterestMobileBackIcon from './hypernova/icons/pinterest-mobile-back.svg'
import PinterestMobileCommentIcon from './hypernova/icons/pinterest-mobile-comment.svg'
import PinterestMobileFlagLgIcon from './hypernova/icons/pinterest-mobile-flag-lg.svg'
import PinterestMobileLikeLgIcon from './hypernova/icons/pinterest-mobile-like-lg.svg'
import PinterestMobileLikeSmIcon from './hypernova/icons/pinterest-mobile-like-sm.svg'
import PinterestMobileMoreIcon from './hypernova/icons/pinterest-mobile-more.svg'
import PinterestMobileMoreSmIcon from './hypernova/icons/pinterest-mobile-more-sm.svg'
import PinterestMobileRepinIcon from './hypernova/icons/pinterest-mobile-repin.svg'
import PinterestMobileRepinLgIcon from './hypernova/icons/pinterest-mobile-repin-lg.svg'
import PinterestMobileSaveIcon from './hypernova/icons/pinterest-mobile-save.svg'
import PinterestMobileSendIcon from './hypernova/icons/pinterest-mobile-send.svg'
import PinterestMobileShareIcon from './hypernova/icons/pinterest-mobile-share.svg'
import PinterestTabletBackIcon from './hypernova/icons/pinterest-tablet-back.svg'
import PinterestTabletFacebookIcon from './hypernova/icons/pinterest-tablet-facebook.svg'
import PinterestTabletLikeIcon from './hypernova/icons/pinterest-tablet-like.svg'
import PinterestTabletLikeLgIcon from './hypernova/icons/pinterest-tablet-like-lg.svg'
import PinterestTabletLikeSmIcon from './hypernova/icons/pinterest-tablet-like-sm.svg'
import PinterestTabletMoreIcon from './hypernova/icons/pinterest-tablet-more.svg'
import PinterestTabletPinitIcon from './hypernova/icons/pinterest-tablet-pinit.svg'
import PinterestTabletRepinIcon from './hypernova/icons/pinterest-tablet-repin.svg'
import PinterestTabletRepinLgIcon from './hypernova/icons/pinterest-tablet-repin-lg.svg'
import PinterestTabletSendIcon from './hypernova/icons/pinterest-tablet-send.svg'
import PlacementsIcon from './hypernova/icons/placements.svg'
import PlayIcon from './hypernova/icons/play.svg'
import PlusIcon from './hypernova/icons/plus.svg'
import PlusSolidIcon from './hypernova/icons/plus-solid.svg'
import PlusSolidXlIcon from './hypernova/icons/plus-solid-xl.svg'
import PresentationThemePromoIcon from './hypernova/icons/presentation-theme-promo.svg'
import PreviewIcon from './hypernova/icons/preview.svg'
import PrinterIcon from './hypernova/icons/printer.svg'
import PrivateIcon from './hypernova/icons/private.svg'
import PublicIcon from './hypernova/icons/public.svg'
import RefreshIcon from './hypernova/icons/refresh.svg'
import RestoreIcon from './hypernova/icons/restore.svg'
import RoadblockChromeIcon from './hypernova/icons/roadblock-chrome.svg'
import RoadblockFirefoxIcon from './hypernova/icons/roadblock-firefox.svg'
import RoadblockIeIcon from './hypernova/icons/roadblock-ie.svg'
import RoadblockSafariIcon from './hypernova/icons/roadblock-safari.svg'
import SearchIcon from './hypernova/icons/search.svg'
import SearchMinusIcon from './hypernova/icons/search-minus.svg'
import SearchPlusIcon from './hypernova/icons/search-plus.svg'
import SettingsLgIcon from './hypernova/icons/settings-lg.svg'
import SettingsThreeKnobsIcon from './hypernova/icons/settings-three-knobs.svg'
import SettingsTwoKnobsIcon from './hypernova/icons/settings-two-knobs.svg'
import ShapeIcon from './hypernova/icons/Shape.svg'
import ShareIcon from './hypernova/icons/share.svg'
import SignOutIcon from './hypernova/icons/sign-out.svg'
import SmsEmojiIcon from './hypernova/icons/sms-emoji.svg'
import SmsMoreIcon from './hypernova/icons/sms-more.svg'
import SmsPlusIcon from './hypernova/icons/sms-plus.svg'
import SmsWestChevronIcon from './hypernova/icons/sms-west-chevron.svg'
import SnapchatMobileChevronUpIcon from './hypernova/icons/snapchat-mobile-chevron-up.svg'
import SnapchatMobileMoreIcon from './hypernova/icons/snapchat-mobile-more.svg'
import StampIcon from './hypernova/icons/stamp.svg'
import StoryIcon from './hypernova/icons/story.svg'
import StoryCutoutIcon from './hypernova/icons/story-cutout.svg'
import TabletIcon from './hypernova/icons/tablet.svg'
import TagIcon from './hypernova/icons/tag.svg'
import ThumbnailEditIcon from './hypernova/icons/thumbnail-edit.svg'
import ThumbnailPlusIcon from './hypernova/icons/thumbnail-plus.svg'
import ThumbsUpIcon from './hypernova/icons/thumbs-up.svg'
import TiktokDesktopChevronEastIcon from './hypernova/icons/tiktok-desktop-chevron-east.svg'
import TiktokDesktopChevronWestIcon from './hypernova/icons/tiktok-desktop-chevron-west.svg'
import TiktokDesktopCloseIcon from './hypernova/icons/tiktok-desktop-close.svg'
import TiktokDesktopCommentIcon from './hypernova/icons/tiktok-desktop-comment.svg'
import TiktokDesktopHeartIcon from './hypernova/icons/tiktok-desktop-heart.svg'
import TiktokDesktopSocialEmbedIcon from './hypernova/icons/tiktok-desktop-social-embed.svg'
import TiktokDesktopSocialFacebookIcon from './hypernova/icons/tiktok-desktop-social-facebook.svg'
import TiktokDesktopSocialPinterestIcon from './hypernova/icons/tiktok-desktop-social-pinterest.svg'
import TiktokDesktopSocialTwitterIcon from './hypernova/icons/tiktok-desktop-social-twitter.svg'
import TiktokDesktopSocialUrlIcon from './hypernova/icons/tiktok-desktop-social-url.svg'
import TiktokDesktopSoundIcon from './hypernova/icons/tiktok-desktop-sound.svg'
import TiktokMobileChevronWestIcon from './hypernova/icons/tiktok-mobile-chevron-west.svg'
import TiktokMobileCommentIcon from './hypernova/icons/tiktok-mobile-comment.svg'
import TiktokMobileEmojiIcon from './hypernova/icons/tiktok-mobile-emoji.svg'
import TiktokMobileFavoriteIcon from './hypernova/icons/tiktok-mobile-favorite.svg'
import TiktokMobileHeartIcon from './hypernova/icons/tiktok-mobile-heart.svg'
import TiktokMobileMentionIcon from './hypernova/icons/tiktok-mobile-mention.svg'
import TiktokMobileRecordIcon from './hypernova/icons/tiktok-mobile-record.svg'
import TiktokMobileShareIcon from './hypernova/icons/tiktok-mobile-share.svg'
import TiktokMobileSoundIcon from './hypernova/icons/tiktok-mobile-sound.svg'
import TimelinesEmptyIcon from './hypernova/icons/timelines-empty.svg'
import TriangleLgEIcon from './hypernova/icons/triangle-lg-e.svg'
import TriangleLgNIcon from './hypernova/icons/triangle-lg-n.svg'
import TriangleLgSIcon from './hypernova/icons/triangle-lg-s.svg'
import TriangleLgWIcon from './hypernova/icons/triangle-lg-w.svg'
import TriangleSmEIcon from './hypernova/icons/triangle-sm-e.svg'
import TriangleSmNIcon from './hypernova/icons/triangle-sm-n.svg'
import TriangleSmSIcon from './hypernova/icons/triangle-sm-s.svg'
import TriangleSmWIcon from './hypernova/icons/triangle-sm-w.svg'
import TrianglesSmEwIcon from './hypernova/icons/triangles-sm-ew.svg'
import TrianglesSmNsIcon from './hypernova/icons/triangles-sm-ns.svg'
import TumblrDesktopCommentIcon from './hypernova/icons/tumblr-desktop-comment.svg'
import TumblrDesktopLikeIcon from './hypernova/icons/tumblr-desktop-like.svg'
import TumblrDesktopLinkChevronIcon from './hypernova/icons/tumblr-desktop-link-chevron.svg'
import TumblrDesktopMoreIcon from './hypernova/icons/tumblr-desktop-more.svg'
import TumblrDesktopReblogIcon from './hypernova/icons/tumblr-desktop-reblog.svg'
import TumblrDesktopShareIcon from './hypernova/icons/tumblr-desktop-share.svg'
import TumblrMobileCommentIcon from './hypernova/icons/tumblr-mobile-comment.svg'
import TumblrMobileLikeIcon from './hypernova/icons/tumblr-mobile-like.svg'
import TumblrMobileLinkChevronIcon from './hypernova/icons/tumblr-mobile-link-chevron.svg'
import TumblrMobileReblogIcon from './hypernova/icons/tumblr-mobile-reblog.svg'
import TumblrMobileShareIcon from './hypernova/icons/tumblr-mobile-share.svg'
import TwitterDesktopCaretIcon from './hypernova/icons/twitter-desktop-caret.svg'
import TwitterDesktopFavoriteIcon from './hypernova/icons/twitter-desktop-favorite.svg'
import TwitterDesktopFollowIcon from './hypernova/icons/twitter-desktop-follow.svg'
import TwitterDesktopMessageIcon from './hypernova/icons/twitter-desktop-message.svg'
import TwitterDesktopMoreIcon from './hypernova/icons/twitter-desktop-more.svg'
import TwitterDesktopProfileCalendarIcon from './hypernova/icons/twitter-desktop-profile-calendar.svg'
import TwitterDesktopProfileClockIcon from './hypernova/icons/twitter-desktop-profile-clock.svg'
import TwitterDesktopProfileGearIcon from './hypernova/icons/twitter-desktop-profile-gear.svg'
import TwitterDesktopProfileLocationIcon from './hypernova/icons/twitter-desktop-profile-location.svg'
import TwitterDesktopProfileMoreIcon from './hypernova/icons/twitter-desktop-profile-more.svg'
import TwitterDesktopProfileUrlIcon from './hypernova/icons/twitter-desktop-profile-url.svg'
import TwitterDesktopProfileVerifiedIcon from './hypernova/icons/twitter-desktop-profile-verified.svg'
import TwitterDesktopReplyIcon from './hypernova/icons/twitter-desktop-reply.svg'
import TwitterDesktopRetweetIcon from './hypernova/icons/twitter-desktop-retweet.svg'
import TwitterDesktopSingleFavoriteIcon from './hypernova/icons/twitter-desktop-single-favorite.svg'
import TwitterDesktopSingleFollowIcon from './hypernova/icons/twitter-desktop-single-follow.svg'
import TwitterDesktopSingleGearIcon from './hypernova/icons/twitter-desktop-single-gear.svg'
import TwitterDesktopSingleReplyIcon from './hypernova/icons/twitter-desktop-single-reply.svg'
import TwitterDesktopSingleRetweetIcon from './hypernova/icons/twitter-desktop-single-retweet.svg'
import TwitterDesktopSingleShareIcon from './hypernova/icons/twitter-desktop-single-share.svg'
import TwitterDesktopStreamCardIcon from './hypernova/icons/twitter-desktop-stream-card.svg'
import TwitterDesktopStreamCardSmIcon from './hypernova/icons/twitter-desktop-stream-card-sm.svg'
import TwitterDesktopStreamFavoriteIcon from './hypernova/icons/twitter-desktop-stream-favorite.svg'
import TwitterDesktopStreamReplyIcon from './hypernova/icons/twitter-desktop-stream-reply.svg'
import TwitterDesktopStreamRetweetIcon from './hypernova/icons/twitter-desktop-stream-retweet.svg'
import TwitterDesktopStreamShareIcon from './hypernova/icons/twitter-desktop-stream-share.svg'
import TwitterDesktopWebsiteCardUrlIcon from './hypernova/icons/twitter-desktop-website-card-url.svg'
import TwitterMobileAppRatingIcon from './hypernova/icons/twitter-mobile-app-rating.svg'
import TwitterMobileCardYellowIcon from './hypernova/icons/twitter-mobile-card-yellow.svg'
import TwitterMobileCaretIcon from './hypernova/icons/twitter-mobile-caret.svg'
import TwitterMobileProfileCalendarIcon from './hypernova/icons/twitter-mobile-profile-calendar.svg'
import TwitterMobileProfileLocationIcon from './hypernova/icons/twitter-mobile-profile-location.svg'
import TwitterMobileProfileUrlIcon from './hypernova/icons/twitter-mobile-profile-url.svg'
import TwitterMobileSingleFavoriteIcon from './hypernova/icons/twitter-mobile-single-favorite.svg'
import TwitterMobileSingleMessageIcon from './hypernova/icons/twitter-mobile-single-message.svg'
import TwitterMobileSingleMoreIcon from './hypernova/icons/twitter-mobile-single-more.svg'
import TwitterMobileSingleReplyIcon from './hypernova/icons/twitter-mobile-single-reply.svg'
import TwitterMobileSingleRetweetIcon from './hypernova/icons/twitter-mobile-single-retweet.svg'
import TwitterMobileSingleShareIcon from './hypernova/icons/twitter-mobile-single-share.svg'
import TwitterMobileStreamFavoriteIcon from './hypernova/icons/twitter-mobile-stream-favorite.svg'
import TwitterMobileStreamFollowIcon from './hypernova/icons/twitter-mobile-stream-follow.svg'
import TwitterMobileStreamFollowSmIcon from './hypernova/icons/twitter-mobile-stream-follow-sm.svg'
import TwitterMobileStreamMessageIcon from './hypernova/icons/twitter-mobile-stream-message.svg'
import TwitterMobileStreamReplyIcon from './hypernova/icons/twitter-mobile-stream-reply.svg'
import TwitterMobileStreamRetweetIcon from './hypernova/icons/twitter-mobile-stream-retweet.svg'
import TwitterMobileStreamShareIcon from './hypernova/icons/twitter-mobile-stream-share.svg'
import UnlockedIcon from './hypernova/icons/unlocked.svg'
import UnlockedLeftIcon from './hypernova/icons/unlocked-left.svg'
import UploadIcon from './hypernova/icons/upload.svg'
import UploadCloudIcon from './hypernova/icons/upload-cloud.svg'
import UploadCloudLgIcon from './hypernova/icons/upload-cloud-lg.svg'
import UrlIcon from './hypernova/icons/url.svg'
import UrlAddIcon from './hypernova/icons/url-add.svg'
import VideoCameraIcon from './hypernova/icons/video-camera.svg'
import ViewColumnIcon from './hypernova/icons/view-column.svg'
import ViewGridIcon from './hypernova/icons/view-grid.svg'
import ViewListIcon from './hypernova/icons/view-list.svg'
import ViewMosaicIcon from './hypernova/icons/view-mosaic.svg'
import ViewSeamlessIcon from './hypernova/icons/view-seamless.svg'
import ViewTilesIcon from './hypernova/icons/view-tiles.svg'
import VineDesktopFollowIcon from './hypernova/icons/vine-desktop-follow.svg'
import VineDesktopMoreIcon from './hypernova/icons/vine-desktop-more.svg'
import VineMobileCommentIcon from './hypernova/icons/vine-mobile-comment.svg'
import VineMobileLikeIcon from './hypernova/icons/vine-mobile-like.svg'
import VineMobileLocationIcon from './hypernova/icons/vine-mobile-location.svg'
import VineMobileMoreIcon from './hypernova/icons/vine-mobile-more.svg'
import VineMobileRevineIcon from './hypernova/icons/vine-mobile-revine.svg'
import VkDesktopHeartIcon from './hypernova/icons/vk-desktop-heart.svg'
import VkDesktopMoreIcon from './hypernova/icons/vk-desktop-more.svg'
import VkDesktopReplyIcon from './hypernova/icons/vk-desktop-reply.svg'
import VkDesktopShareIcon from './hypernova/icons/vk-desktop-share.svg'
import VkDesktopViewsIcon from './hypernova/icons/vk-desktop-views.svg'
import VkMobileHeartIcon from './hypernova/icons/vk-mobile-heart.svg'
import VkMobileMoreIcon from './hypernova/icons/vk-mobile-more.svg'
import VkMobileReplyIcon from './hypernova/icons/vk-mobile-reply.svg'
import VkMobileShareIcon from './hypernova/icons/vk-mobile-share.svg'
import VkMobileViewsIcon from './hypernova/icons/vk-mobile-views.svg'
import WarningIcon from './hypernova/icons/warning.svg'
import WarningSmIcon from './hypernova/icons/warning-sm.svg'
import WeiboDesktopChevronIcon from './hypernova/icons/weibo-desktop-chevron.svg'
import WeiboDesktopCollapseIcon from './hypernova/icons/weibo-desktop-collapse.svg'
import WeiboDesktopLikeIcon from './hypernova/icons/weibo-desktop-like.svg'
import WeiboDesktopLinkIcon from './hypernova/icons/weibo-desktop-link.svg'
import WeiboMobileCommentIcon from './hypernova/icons/weibo-mobile-comment.svg'
import WeiboMobileFollowPlusIcon from './hypernova/icons/weibo-mobile-follow-plus.svg'
import WeiboMobileLikeIcon from './hypernova/icons/weibo-mobile-like.svg'
import WeiboMobileLinkIcon from './hypernova/icons/weibo-mobile-link.svg'
import WeiboMobileShareIcon from './hypernova/icons/weibo-mobile-share.svg'
import WorkflowIcon from './hypernova/icons/workflow.svg'
import YoutubeDesktopAddToPlaylistIcon from './hypernova/icons/youtube-desktop-add-to-playlist.svg'
import YoutubeDesktopLikeIcon from './hypernova/icons/youtube-desktop-like.svg'
import YoutubeDesktopMoreIcon from './hypernova/icons/youtube-desktop-more.svg'
import YoutubeDesktopShareIcon from './hypernova/icons/youtube-desktop-share.svg'
import YoutubeDesktopShortCommentIcon from './hypernova/icons/youtube-desktop-short-comment.svg'
import YoutubeDesktopShortDislikeIcon from './hypernova/icons/youtube-desktop-short-dislike.svg'
import YoutubeDesktopShortLikeIcon from './hypernova/icons/youtube-desktop-short-like.svg'
import YoutubeDesktopShortMoreIcon from './hypernova/icons/youtube-desktop-short-more.svg'
import YoutubeDesktopShortShareIcon from './hypernova/icons/youtube-desktop-short-share.svg'
import YoutubeDesktopShortSoundIcon from './hypernova/icons/youtube-desktop-short-sound.svg'
import YoutubeDesktopSubscribeIcon from './hypernova/icons/youtube-desktop-subscribe.svg'
import YoutubeMobileCollapseIcon from './hypernova/icons/youtube-mobile-collapse.svg'
import YoutubeMobileDislikeIcon from './hypernova/icons/youtube-mobile-dislike.svg'
import YoutubeMobileLikeIcon from './hypernova/icons/youtube-mobile-like.svg'
import YoutubeMobileShortChevronEastIcon from './hypernova/icons/youtube-mobile-short-chevron-east.svg'
import YoutubeMobileShortCommentIcon from './hypernova/icons/youtube-mobile-short-comment.svg'
import YoutubeMobileShortDislikeIcon from './hypernova/icons/youtube-mobile-short-dislike.svg'
import YoutubeMobileShortLikeIcon from './hypernova/icons/youtube-mobile-short-like.svg'
import YoutubeMobileShortNoteIcon from './hypernova/icons/youtube-mobile-short-note.svg'
import YoutubeMobileShortPromotionIcon from './hypernova/icons/youtube-mobile-short-promotion.svg'
import YoutubeMobileShortRemixIcon from './hypernova/icons/youtube-mobile-short-remix.svg'
import YoutubeMobileShortShareIcon from './hypernova/icons/youtube-mobile-short-share.svg'
import YoutubeMobileShortSoundIcon from './hypernova/icons/youtube-mobile-short-sound.svg'
import GemAddIcon from './gem/icons/gem-add.svg'
import GemAddCheckboxIcon from './gem/icons/gem-add-checkbox.svg'
import GemAddCircleFilledIcon from './gem/icons/gem-add-circle-filled.svg'
import GemAddLinkIcon from './gem/icons/gem-add-link.svg'
import GemAddSmallIcon from './gem/icons/gem-add-small.svg'
import GemAddTableIcon from './gem/icons/gem-add-table.svg'
import GemAiIcon from './gem/icons/gem-ai.svg'
import GemAiWhiteIcon from './gem/icons/gem-ai-white.svg'
import GemAiWhiteSparkleIcon from './gem/icons/gem-ai-white-sparkle.svg'
import GemAirplaneIcon from './gem/icons/gem-airplane.svg'
import GemAlignCenterIcon from './gem/icons/gem-align-center.svg'
import GemAlignJustifiedIcon from './gem/icons/gem-align-justified.svg'
import GemAlignLeftIcon from './gem/icons/gem-align-left.svg'
import GemAlignRightIcon from './gem/icons/gem-align-right.svg'
import GemArchiveIcon from './gem/icons/gem-archive.svg'
import GemArrowNsIcon from './gem/icons/gem-arrow-ns.svg'
import GemAssignmentsIcon from './gem/icons/gem-assignments.svg'
import GemBellIcon from './gem/icons/gem-bell.svg'
import GemBellFillIcon from './gem/icons/gem-bell-fill.svg'
import GemBellHiddenIcon from './gem/icons/gem-bell-hidden.svg'
import GemBlockFilledDarkIcon from './gem/icons/gem-block-filled-dark.svg'
import GemBlockFilledLightIcon from './gem/icons/gem-block-filled-light.svg'
import GemBlockOutlinedIcon from './gem/icons/gem-block-outlined.svg'
import GemBoldIcon from './gem/icons/gem-bold.svg'
import GemBooksIcon from './gem/icons/gem-books.svg'
import GemBulletListIcon from './gem/icons/gem-bullet-list.svg'
import GemCalculatorIcon from './gem/icons/gem-calculator.svg'
import GemCalendarIcon from './gem/icons/gem-calendar.svg'
import GemCalendarTodayIcon from './gem/icons/gem-calendar-today.svg'
import GemCardIcon from './gem/icons/gem-card.svg'
import GemCascadeIcon from './gem/icons/gem-cascade.svg'
import GemChannelAllIcon from './gem/icons/gem-channel-all.svg'
import GemChannelAllFilledIcon from './gem/icons/gem-channel-all-filled.svg'
import GemChannelAudioIcon from './gem/icons/gem-channel-audio.svg'
import GemChannelAudioFilledIcon from './gem/icons/gem-channel-audio-filled.svg'
import GemChannelBlogIcon from './gem/icons/gem-channel-blog.svg'
import GemChannelBlogFilledIcon from './gem/icons/gem-channel-blog-filled.svg'
import GemChannelBlueskyIcon from './gem/icons/gem-channel-bluesky.svg'
import GemChannelBlueskyFilledIcon from './gem/icons/gem-channel-bluesky-filled.svg'
import GemChannelCalendarIcon from './gem/icons/gem-channel-calendar.svg'
import GemChannelCalendarFilledIcon from './gem/icons/gem-channel-calendar-filled.svg'
import GemChannelDigitalAdIcon from './gem/icons/gem-channel-digital-ad.svg'
import GemChannelDigitalAdFilledIcon from './gem/icons/gem-channel-digital-ad-filled.svg'
import GemChannelDisplayAdIcon from './gem/icons/gem-channel-display-ad.svg'
import GemChannelDisplayAdFilledIcon from './gem/icons/gem-channel-display-ad-filled.svg'
import GemChannelEmailIcon from './gem/icons/gem-channel-email.svg'
import GemChannelEmailFilledIcon from './gem/icons/gem-channel-email-filled.svg'
import GemChannelFacebookIcon from './gem/icons/gem-channel-facebook.svg'
import GemChannelFacebookFilledIcon from './gem/icons/gem-channel-facebook-filled.svg'
import GemChannelFlickrIcon from './gem/icons/gem-channel-flickr.svg'
import GemChannelFlickrFilledIcon from './gem/icons/gem-channel-flickr-filled.svg'
import GemChannelFoursquareIcon from './gem/icons/gem-channel-foursquare.svg'
import GemChannelFoursquareFilledIcon from './gem/icons/gem-channel-foursquare-filled.svg'
import GemChannelGoogleplusIcon from './gem/icons/gem-channel-googleplus.svg'
import GemChannelGoogleplusFilledIcon from './gem/icons/gem-channel-googleplus-filled.svg'
import GemChannelInstagramIcon from './gem/icons/gem-channel-instagram.svg'
import GemChannelInstagramFilledIcon from './gem/icons/gem-channel-instagram-filled.svg'
import GemChannelLinkedinIcon from './gem/icons/gem-channel-linkedin.svg'
import GemChannelLinkedinFilledIcon from './gem/icons/gem-channel-linkedin-filled.svg'
import GemChannelListIcon from './gem/icons/gem-channel-list.svg'
import GemChannelListFilledIcon from './gem/icons/gem-channel-list-filled.svg'
import GemChannelMailIcon from './gem/icons/gem-channel-mail.svg'
import GemChannelMailFilledIcon from './gem/icons/gem-channel-mail-filled.svg'
import GemChannelMessageIcon from './gem/icons/gem-channel-message.svg'
import GemChannelMessageFilledIcon from './gem/icons/gem-channel-message-filled.svg'
import GemChannelMoreIcon from './gem/icons/gem-channel-more.svg'
import GemChannelMoreFilledIcon from './gem/icons/gem-channel-more-filled.svg'
import GemChannelPhotoIcon from './gem/icons/gem-channel-photo.svg'
import GemChannelPhotoFilledIcon from './gem/icons/gem-channel-photo-filled.svg'
import GemChannelPinterestIcon from './gem/icons/gem-channel-pinterest.svg'
import GemChannelPinterestFilledIcon from './gem/icons/gem-channel-pinterest-filled.svg'
import GemChannelPrintIcon from './gem/icons/gem-channel-print.svg'
import GemChannelPrintFilledIcon from './gem/icons/gem-channel-print-filled.svg'
import GemChannelRedditIcon from './gem/icons/gem-channel-reddit.svg'
import GemChannelRedditFilledIcon from './gem/icons/gem-channel-reddit-filled.svg'
import GemChannelSmsIcon from './gem/icons/gem-channel-sms.svg'
import GemChannelSnapchatIcon from './gem/icons/gem-channel-snapchat.svg'
import GemChannelSnapchatFilledIcon from './gem/icons/gem-channel-snapchat-filled.svg'
import GemChannelStarIcon from './gem/icons/gem-channel-star.svg'
import GemChannelStarFilledIcon from './gem/icons/gem-channel-star-filled.svg'
import GemChannelThreadsIcon from './gem/icons/gem-channel-threads.svg'
import GemChannelThreadsFilledIcon from './gem/icons/gem-channel-threads-filled.svg'
import GemChannelTiktokIcon from './gem/icons/gem-channel-tiktok.svg'
import GemChannelTiktokFilledIcon from './gem/icons/gem-channel-tiktok-filled.svg'
import GemChannelTumblrIcon from './gem/icons/gem-channel-tumblr.svg'
import GemChannelTumblrFilledIcon from './gem/icons/gem-channel-tumblr-filled.svg'
import GemChannelTwitterIcon from './gem/icons/gem-channel-twitter.svg'
import GemChannelTwitterFilledIcon from './gem/icons/gem-channel-twitter-filled.svg'
import GemChannelVideoIcon from './gem/icons/gem-channel-video.svg'
import GemChannelVideoFilledIcon from './gem/icons/gem-channel-video-filled.svg'
import GemChannelVimeoIcon from './gem/icons/gem-channel-vimeo.svg'
import GemChannelVimeoFilledIcon from './gem/icons/gem-channel-vimeo-filled.svg'
import GemChannelVineIcon from './gem/icons/gem-channel-vine.svg'
import GemChannelVineFilledIcon from './gem/icons/gem-channel-vine-filled.svg'
import GemChannelVkIcon from './gem/icons/gem-channel-vk.svg'
import GemChannelVkFilledIcon from './gem/icons/gem-channel-vk-filled.svg'
import GemChannelWebFilledIcon from './gem/icons/gem-channel-web-filled.svg'
import GemChannelWebModuleFilledIcon from './gem/icons/gem-channel-web-module-filled.svg'
import GemChannelWebModulesIcon from './gem/icons/gem-channel-web-modules.svg'
import GemChannelWebsiteIcon from './gem/icons/gem-channel-website.svg'
import GemChannelWeiboIcon from './gem/icons/gem-channel-weibo.svg'
import GemChannelWeiboFilledIcon from './gem/icons/gem-channel-weibo-filled.svg'
import GemChannelWordpressIcon from './gem/icons/gem-channel-wordpress.svg'
import GemChannelWordpressFilledIcon from './gem/icons/gem-channel-wordpress-filled.svg'
import GemChannelYoutubeIcon from './gem/icons/gem-channel-youtube.svg'
import GemChannelYoutubeFilledIcon from './gem/icons/gem-channel-youtube-filled.svg'
import GemChatIcon from './gem/icons/gem-chat.svg'
import GemCheckIcon from './gem/icons/gem-check.svg'
import GemCheckCircleIcon from './gem/icons/gem-check-circle.svg'
import GemCheckCircleFilledIcon from './gem/icons/gem-check-circle-filled.svg'
import GemCheckDashedCircleIcon from './gem/icons/gem-check-dashed-circle.svg'
import GemCheckDashedCircleFilledIcon from './gem/icons/gem-check-dashed-circle-filled.svg'
import GemCheckDeliveryIcon from './gem/icons/gem-check-delivery.svg'
import GemCheckDeliveryFilledIcon from './gem/icons/gem-check-delivery-filled.svg'
import GemChevronEIcon from './gem/icons/gem-chevron-e.svg'
import GemChevronNIcon from './gem/icons/gem-chevron-n.svg'
import GemChevronSIcon from './gem/icons/gem-chevron-s.svg'
import GemChevronWIcon from './gem/icons/gem-chevron-w.svg'
import GemCircleIcon from './gem/icons/gem-circle.svg'
import GemCircleDeliveryIcon from './gem/icons/gem-circle-delivery.svg'
import GemCircleDeliveryFilledIcon from './gem/icons/gem-circle-delivery-filled.svg'
import GemClockIcon from './gem/icons/gem-clock.svg'
import GemCloseIcon from './gem/icons/gem-close.svg'
import GemCloseCircleIcon from './gem/icons/gem-close-circle.svg'
import GemCloseCircleFilledIcon from './gem/icons/gem-close-circle-filled.svg'
import GemCloseDeliveryIcon from './gem/icons/gem-close-delivery.svg'
import GemCloseDeliveryFilledIcon from './gem/icons/gem-close-delivery-filled.svg'
import GemCloseSmallIcon from './gem/icons/gem-close-small.svg'
import GemCloudIcon from './gem/icons/gem-cloud.svg'
import GemCogIcon from './gem/icons/gem-cog.svg'
import GemColumnsIcon from './gem/icons/gem-columns.svg'
import GemCommentIcon from './gem/icons/gem-comment.svg'
import GemCondensedModeIcon from './gem/icons/gem-condensed-mode.svg'
import GemConnectionIcon from './gem/icons/gem-connection.svg'
import GemContentFilledDarkIcon from './gem/icons/gem-content-filled-dark.svg'
import GemContentFilledLightIcon from './gem/icons/gem-content-filled-light.svg'
import GemContentOutlinedIcon from './gem/icons/gem-content-outlined.svg'
import GemContentQueueIcon from './gem/icons/gem-content-queue.svg'
import GemCopyIcon from './gem/icons/gem-copy.svg'
import GemDashCircleIcon from './gem/icons/gem-dash-circle.svg'
import GemDashCircleFilledIcon from './gem/icons/gem-dash-circle-filled.svg'
import GemDashDeliveryIcon from './gem/icons/gem-dash-delivery.svg'
import GemDashDeliveryFilledIcon from './gem/icons/gem-dash-delivery-filled.svg'
import GemDeliveryIcon from './gem/icons/gem-delivery.svg'
import GemDownloadIcon from './gem/icons/gem-download.svg'
import GemDownloadCloudIcon from './gem/icons/gem-download-cloud.svg'
import GemEditIcon from './gem/icons/gem-edit.svg'
import GemEmptyImageIllustration from './gem/illustrations/gem-empty-image.svg'
import GemErrorCircleIcon from './gem/icons/gem-error-circle.svg'
import GemEyeIcon from './gem/icons/gem-eye.svg'
import GemEyeHiddenIcon from './gem/icons/gem-eye-hidden.svg'
import GemFileIcon from './gem/icons/gem-file.svg'
import GemFilterIcon from './gem/icons/gem-filter.svg'
import GemFullModeIcon from './gem/icons/gem-full-mode.svg'
import GemFullScreenIcon from './gem/icons/gem-full-screen.svg'
import GemGlobeIcon from './gem/icons/gem-globe.svg'
import GemGraphIcon from './gem/icons/gem-graph.svg'
import GemGridIcon from './gem/icons/gem-grid.svg'
import GemH1Icon from './gem/icons/gem-h1.svg'
import GemH2Icon from './gem/icons/gem-h2.svg'
import GemH3Icon from './gem/icons/gem-h3.svg'
import GemH4Icon from './gem/icons/gem-h4.svg'
import GemHamburgerMenuIcon from './gem/icons/gem-hamburger-menu.svg'
import GemHighlightIcon from './gem/icons/gem-highlight.svg'
import GemImageIcon from './gem/icons/gem-image.svg'
import GemImageAddIcon from './gem/icons/gem-image-add.svg'
import GemIndentIcon from './gem/icons/gem-indent.svg'
import GemInfoCircleIcon from './gem/icons/gem-info-circle.svg'
import GemInfoCircleFilledIcon from './gem/icons/gem-info-circle-filled.svg'
import GemItalicIcon from './gem/icons/gem-italic.svg'
import GemJournalIcon from './gem/icons/gem-journal.svg'
import GemLabelIcon from './gem/icons/gem-label.svg'
import GemLabelSetIcon from './gem/icons/gem-label-set.svg'
import GemLifesaverIcon from './gem/icons/gem-lifesaver.svg'
import GemLinkIcon from './gem/icons/gem-link.svg'
import GemLocationIcon from './gem/icons/gem-location.svg'
import GemLockedIcon from './gem/icons/gem-locked.svg'
import GemMinusIcon from './gem/icons/gem-minus.svg'
import GemMinusCircleFilledIcon from './gem/icons/gem-minus-circle-filled.svg'
import GemMomentFilledDarkIcon from './gem/icons/gem-moment-filled-dark.svg'
import GemMomentFilledLightIcon from './gem/icons/gem-moment-filled-light.svg'
import GemMomentOutlinedIcon from './gem/icons/gem-moment-outlined.svg'
import GemMomentsIcon from './gem/icons/gem-moments.svg'
import GemMoreHorizontalIcon from './gem/icons/gem-more-horizontal.svg'
import GemMoreVerticalIcon from './gem/icons/gem-more-vertical.svg'
import GemMosaicIcon from './gem/icons/gem-mosaic.svg'
import GemMultipleChoiceIcon from './gem/icons/gem-multiple-choice.svg'
import GemNoHighlightIcon from './gem/icons/gem-no-highlight.svg'
import GemNoSearchResultIllustration from './gem/illustrations/gem-no-search-result.svg'
import GemNoTextColorIcon from './gem/icons/gem-no-text-color.svg'
import GemNoteIcon from './gem/icons/gem-note.svg'
import GemNumberedListIcon from './gem/icons/gem-numbered-list.svg'
import GemOpalLogoIcon from './gem/icons/gem-opal-logo.svg'
import GemOpalWordmarkIcon from './gem/icons/gem-opal-wordmark.svg'
import GemOpalWordmarkPrideIcon from './gem/icons/gem-opal-wordmark-pride.svg'
import GemParagraphIcon from './gem/icons/gem-paragraph.svg'
import GemPauseCircleIcon from './gem/icons/gem-pause-circle.svg'
import GemPauseCircleFilledIcon from './gem/icons/gem-pause-circle-filled.svg'
import GemPhoneIcon from './gem/icons/gem-phone.svg'
import GemPhotoAttachmentIcon from './gem/icons/gem-photo-attachment.svg'
import GemPiechartIcon from './gem/icons/gem-piechart.svg'
import GemPlanBuilderIllustration from './gem/illustrations/gem-plan-builder.svg'
import GemPlansIcon from './gem/icons/gem-plans.svg'
import GemPlayIcon from './gem/icons/gem-play.svg'
import GemPopoutIcon from './gem/icons/gem-popout.svg'
import GemPresentationsIcon from './gem/icons/gem-presentations.svg'
import GemQuestionMarkIcon from './gem/icons/gem-question-mark.svg'
import GemQuoteIcon from './gem/icons/gem-quote.svg'
import GemRedditIcon from './gem/icons/gem-reddit.svg'
import GemReddit14Icon from './gem/icons/gem-reddit-14.svg'
import GemRedditCommentIcon from './gem/icons/gem-reddit-comment.svg'
import GemRedditDownvoteIcon from './gem/icons/gem-reddit-downvote.svg'
import GemRedditShareIcon from './gem/icons/gem-reddit-share.svg'
import GemRedditUpvoteIcon from './gem/icons/gem-reddit-upvote.svg'
import GemReturnIcon from './gem/icons/gem-return.svg'
import GemRowsStackedIcon from './gem/icons/gem-rows-stacked.svg'
import GemSearchIcon from './gem/icons/gem-search.svg'
import GemSettingsIcon from './gem/icons/gem-settings.svg'
import GemShareIcon from './gem/icons/gem-share.svg'
import GemSidebarLeftIcon from './gem/icons/gem-sidebar-left.svg'
import GemSidebarRightIcon from './gem/icons/gem-sidebar-right.svg'
import GemSingleChoiceIcon from './gem/icons/gem-single-choice.svg'
import GemSortAscendingIcon from './gem/icons/gem-sort-ascending.svg'
import GemSortDescendingIcon from './gem/icons/gem-sort-descending.svg'
import GemSortUnsortedIcon from './gem/icons/gem-sort-unsorted.svg'
import GemSparkleIcon from './gem/icons/gem-sparkle.svg'
import GemSparkleFilledIcon from './gem/icons/gem-sparkle-filled.svg'
import GemSpeechBubbleQuestionMarkIcon from './gem/icons/gem-speech-bubble-question-mark.svg'
import GemStampIcon from './gem/icons/gem-stamp.svg'
import GemStarFillIcon from './gem/icons/gem-star-fill.svg'
import GemStarOutlineIcon from './gem/icons/gem-star-outline.svg'
import GemStatusIcon from './gem/icons/gem-status.svg'
import GemStoriesIcon from './gem/icons/gem-stories.svg'
import GemStoryFilledDarkIcon from './gem/icons/gem-story-filled-dark.svg'
import GemStoryFilledLightIcon from './gem/icons/gem-story-filled-light.svg'
import GemStoryOutlinedIcon from './gem/icons/gem-story-outlined.svg'
import GemStrikethroughIcon from './gem/icons/gem-strikethrough.svg'
import GemSubmitIcon from './gem/icons/gem-submit.svg'
import GemSubscriptIcon from './gem/icons/gem-subscript.svg'
import GemSuperscriptIcon from './gem/icons/gem-superscript.svg'
import GemSwimlaneIcon from './gem/icons/gem-swimlane.svg'
import GemSwimlaneGroupIcon from './gem/icons/gem-swimlane-group.svg'
import GemTasksIcon from './gem/icons/gem-tasks.svg'
import GemTextIcon from './gem/icons/gem-text.svg'
import GemTextColorIcon from './gem/icons/gem-text-color.svg'
import GemThumbsDownIcon from './gem/icons/gem-thumbs-down.svg'
import GemThumbsDownCircleIcon from './gem/icons/gem-thumbs-down-circle.svg'
import GemThumbsDownCircleFilledIcon from './gem/icons/gem-thumbs-down-circle-filled.svg'
import GemThumbsUpIcon from './gem/icons/gem-thumbs-up.svg'
import GemThumbsUpCircleIcon from './gem/icons/gem-thumbs-up-circle.svg'
import GemThumbsUpCircleFilledIcon from './gem/icons/gem-thumbs-up-circle-filled.svg'
import GemThumbsUpDashedCircleIcon from './gem/icons/gem-thumbs-up-dashed-circle.svg'
import GemThumbsUpDashedCircleFilledIcon from './gem/icons/gem-thumbs-up-dashed-circle-filled.svg'
import GemTimelinesIcon from './gem/icons/gem-timelines.svg'
import GemToggleIcon from './gem/icons/gem-toggle.svg'
import GemTrashIcon from './gem/icons/gem-trash.svg'
import GemTwoThumbsUpIcon from './gem/icons/gem-two-thumbs-up.svg'
import GemTypeIcon from './gem/icons/gem-type.svg'
import GemUnderlineIcon from './gem/icons/gem-underline.svg'
import GemUnlockedIcon from './gem/icons/gem-unlocked.svg'
import GemUploadIcon from './gem/icons/gem-upload.svg'
import GemUploadCloudIcon from './gem/icons/gem-upload-cloud.svg'
import GemUploadFileAttachmentIcon from './gem/icons/gem-upload-file-attachment.svg'
import GemUserIcon from './gem/icons/gem-user.svg'
import GemUsersIcon from './gem/icons/gem-users.svg'
import GemVersionHistoryIcon from './gem/icons/gem-version-history.svg'
import GemViewIcon from './gem/icons/gem-view.svg'
import GemWarningIcon from './gem/icons/gem-warning.svg'
import GemWarningDeliveryIcon from './gem/icons/gem-warning-delivery.svg'
import GemWarningDeliveryFilledIcon from './gem/icons/gem-warning-delivery-filled.svg'
import GemWarningFilledIcon from './gem/icons/gem-warning-filled.svg'
import GemWorkflowIcon from './gem/icons/gem-workflow.svg'
import GemWorkspaceIcon from './gem/icons/gem-workspace.svg'

export const hypernova = {
  actions: ActionsIcon,
  'actions-xl': ActionsXlIcon,
  activity: ActivityIcon,
  'admin-cogs': AdminCogsIcon,
  alert: AlertIcon,
  annotate: AnnotateIcon,
  announcement: AnnouncementIcon,
  'app-people': AppPeopleIcon,
  'app-presentations': AppPresentationsIcon,
  'app-workspaces': AppWorkspacesIcon,
  approval: ApprovalIcon,
  'approval-pause': ApprovalPauseIcon,
  'approve-with-comment': ApproveWithCommentIcon,
  'arrow-e': ArrowEIcon,
  'arrow-n': ArrowNIcon,
  'arrow-ns': ArrowNsIcon,
  'arrow-s': ArrowSIcon,
  'arrow-w': ArrowWIcon,
  'asset-library': AssetLibraryIcon,
  assets: AssetsIcon,
  'assignments-empty': AssignmentsEmptyIcon,
  'bar-graph': BarGraphIcon,
  brief: BriefIcon,
  browse: BrowseIcon,
  'bs-approvals': BsApprovalsIcon,
  'bs-assignments': BsAssignmentsIcon,
  'bs-configure': BsConfigureIcon,
  'bs-content-queue': BsContentQueueIcon,
  'bs-moments': BsMomentsIcon,
  'bs-paused-queue': BsPausedQueueIcon,
  'bs-stories': BsStoriesIcon,
  'bs-timeline': BsTimelineIcon,
  'bs-timelines': BsTimelinesIcon,
  'bs-workspace-directory': BsWorkspaceDirectoryIcon,
  'budget-m': BudgetMIcon,
  calendar: CalendarIcon,
  card: CardIcon,
  cardless: CardlessIcon,
  'channel-ad': ChannelAdIcon,
  'channel-ad-14': ChannelAd14Icon,
  'channel-ad-sm': ChannelAdSmIcon,
  'channel-all': ChannelAllIcon,
  'channel-all-14': ChannelAll14Icon,
  'channel-all-sm': ChannelAllSmIcon,
  'channel-audio': ChannelAudioIcon,
  'channel-audio-14': ChannelAudio14Icon,
  'channel-audio-sm': ChannelAudioSmIcon,
  'channel-blog': ChannelBlogIcon,
  'channel-blog-14': ChannelBlog14Icon,
  'channel-blog-sm': ChannelBlogSmIcon,
  'channel-bluesky': ChannelBlueskyIcon,
  'channel-bluesky-14': ChannelBluesky14Icon,
  'channel-bluesky-sm': ChannelBlueskySmIcon,
  'channel-calendar': ChannelCalendarIcon,
  'channel-calendar-14': ChannelCalendar14Icon,
  'channel-calendar-sm': ChannelCalendarSmIcon,
  'channel-display-ad': ChannelDisplayAdIcon,
  'channel-display-ad-14': ChannelDisplayAd14Icon,
  'channel-display-ad-sm': ChannelDisplayAdSmIcon,
  'channel-email': ChannelEmailIcon,
  'channel-email-14': ChannelEmail14Icon,
  'channel-email-sm': ChannelEmailSmIcon,
  'channel-facebook': ChannelFacebookIcon,
  'channel-facebook-14': ChannelFacebook14Icon,
  'channel-facebook-sm': ChannelFacebookSmIcon,
  'channel-flickr': ChannelFlickrIcon,
  'channel-flickr-14': ChannelFlickr14Icon,
  'channel-flickr-sm': ChannelFlickrSmIcon,
  'channel-foursquare': ChannelFoursquareIcon,
  'channel-foursquare-14': ChannelFoursquare14Icon,
  'channel-foursquare-sm': ChannelFoursquareSmIcon,
  'channel-googleplus': ChannelGoogleplusIcon,
  'channel-googleplus-14': ChannelGoogleplus14Icon,
  'channel-googleplus-sm': ChannelGoogleplusSmIcon,
  'channel-instagram': ChannelInstagramIcon,
  'channel-instagram-14': ChannelInstagram14Icon,
  'channel-instagram-sm': ChannelInstagramSmIcon,
  'channel-linkedin': ChannelLinkedinIcon,
  'channel-linkedin-14': ChannelLinkedin14Icon,
  'channel-linkedin-sm': ChannelLinkedinSmIcon,
  'channel-list': ChannelListIcon,
  'channel-list-14': ChannelList14Icon,
  'channel-list-sm': ChannelListSmIcon,
  'channel-mail': ChannelMailIcon,
  'channel-mail-14': ChannelMail14Icon,
  'channel-mail-sm': ChannelMailSmIcon,
  'channel-message': ChannelMessageIcon,
  'channel-message-14': ChannelMessage14Icon,
  'channel-message-sm': ChannelMessageSmIcon,
  'channel-more': ChannelMoreIcon,
  'channel-more-14': ChannelMore14Icon,
  'channel-more-sm': ChannelMoreSmIcon,
  'channel-nike': ChannelNikeIcon,
  'channel-nike-14': ChannelNike14Icon,
  'channel-nike-sm': ChannelNikeSmIcon,
  'channel-photo': ChannelPhotoIcon,
  'channel-photo-14': ChannelPhoto14Icon,
  'channel-photo-sm': ChannelPhotoSmIcon,
  'channel-pinterest': ChannelPinterestIcon,
  'channel-pinterest-14': ChannelPinterest14Icon,
  'channel-pinterest-sm': ChannelPinterestSmIcon,
  'channel-print': ChannelPrintIcon,
  'channel-print-14': ChannelPrint14Icon,
  'channel-print-sm': ChannelPrintSmIcon,
  'channel-reddit': ChannelRedditIcon,
  'channel-reddit-14': ChannelReddit14Icon,
  'channel-reddit-sm': ChannelRedditSmIcon,
  'channel-sms': ChannelSmsIcon,
  'channel-sms-14': ChannelSms14Icon,
  'channel-sms-sm': ChannelSmsSmIcon,
  'channel-snapchat': ChannelSnapchatIcon,
  'channel-snapchat-14': ChannelSnapchat14Icon,
  'channel-snapchat-sm': ChannelSnapchatSmIcon,
  'channel-star': ChannelStarIcon,
  'channel-star-14': ChannelStar14Icon,
  'channel-star-sm': ChannelStarSmIcon,
  'channel-threads': ChannelThreadsIcon,
  'channel-threads-14': ChannelThreads14Icon,
  'channel-threads-sm': ChannelThreadsSmIcon,
  'channel-tiktok': ChannelTiktokIcon,
  'channel-tiktok-14': ChannelTiktok14Icon,
  'channel-tiktok-sm': ChannelTiktokSmIcon,
  'channel-tumblr': ChannelTumblrIcon,
  'channel-tumblr-14': ChannelTumblr14Icon,
  'channel-tumblr-sm': ChannelTumblrSmIcon,
  'channel-twitter': ChannelTwitterIcon,
  'channel-twitter-14': ChannelTwitter14Icon,
  'channel-twitter-sm': ChannelTwitterSmIcon,
  'channel-video': ChannelVideoIcon,
  'channel-video-14': ChannelVideo14Icon,
  'channel-video-sm': ChannelVideoSmIcon,
  'channel-vimeo': ChannelVimeoIcon,
  'channel-vimeo-14': ChannelVimeo14Icon,
  'channel-vimeo-sm': ChannelVimeoSmIcon,
  'channel-vine': ChannelVineIcon,
  'channel-vine-14': ChannelVine14Icon,
  'channel-vine-sm': ChannelVineSmIcon,
  'channel-vk': ChannelVkIcon,
  'channel-vk-14': ChannelVk14Icon,
  'channel-vk-sm': ChannelVkSmIcon,
  'channel-web-modules': ChannelWebModulesIcon,
  'channel-web-modules-14': ChannelWebModules14Icon,
  'channel-web-modules-sm': ChannelWebModulesSmIcon,
  'channel-website': ChannelWebsiteIcon,
  'channel-website-14': ChannelWebsite14Icon,
  'channel-website-sm': ChannelWebsiteSmIcon,
  'channel-weibo': ChannelWeiboIcon,
  'channel-weibo-14': ChannelWeibo14Icon,
  'channel-weibo-sm': ChannelWeiboSmIcon,
  'channel-wordpress': ChannelWordpressIcon,
  'channel-wordpress-14': ChannelWordpress14Icon,
  'channel-wordpress-sm': ChannelWordpressSmIcon,
  'channel-youtube': ChannelYoutubeIcon,
  'channel-youtube-14': ChannelYoutube14Icon,
  'channel-youtube-sm': ChannelYoutubeSmIcon,
  'channels-sms': ChannelsSmsIcon,
  'chat-activity': ChatActivityIcon,
  'check-in': CheckInIcon,
  'check-out': CheckOutIcon,
  'check-out-disabled': CheckOutDisabledIcon,
  checkmark: CheckmarkIcon,
  'checkmark copy 6': CheckmarkCopy6Icon,
  'checkmark-sm': CheckmarkSmIcon,
  'chevron-color': ChevronColorIcon,
  'chevron-e': ChevronEIcon,
  'chevron-lg-e': ChevronLgEIcon,
  'chevron-lg-n': ChevronLgNIcon,
  'chevron-lg-s': ChevronLgSIcon,
  'chevron-lg-w': ChevronLgWIcon,
  'chevron-n': ChevronNIcon,
  'chevron-s': ChevronSIcon,
  'chevron-w': ChevronWIcon,
  circle: CircleIcon,
  clock: ClockIcon,
  'close-circle': CloseCircleIcon,
  'close-lg': CloseLgIcon,
  'close-sm': CloseSmIcon,
  'cog-lg': CogLgIcon,
  'cog-sm': CogSmIcon,
  'cog-xl': CogXlIcon,
  collapse: CollapseIcon,
  'comment-empty': CommentEmptyIcon,
  'comment-filled': CommentFilledIcon,
  content: ContentIcon,
  'content-cutout': ContentCutoutIcon,
  'content-delivery': ContentDeliveryIcon,
  'content-hold': ContentHoldIcon,
  'cover-image': CoverImageIcon,
  create: CreateIcon,
  crosshair: CrosshairIcon,
  'csv-export': CsvExportIcon,
  'csv-export-illo': CsvExportIlloIcon,
  decline: DeclineIcon,
  delete: DeleteIcon,
  desktop: DesktopIcon,
  'donut-chart': DonutChartIcon,
  download: DownloadIcon,
  'drawer-close': DrawerCloseIcon,
  'drawer-open': DrawerOpenIcon,
  'drop-arrow': DropArrowIcon,
  'drop-arrow-plus': DropArrowPlusIcon,
  'duplicate-content': DuplicateContentIcon,
  edit: EditIcon,
  ellipsis: EllipsisIcon,
  'emoji-in-chat': EmojiInChatIcon,
  enter: EnterIcon,
  esc: EscIcon,
  expand: ExpandIcon,
  eye: EyeIcon,
  'eye-hidden': EyeHiddenIcon,
  'facebook-desktop-ad-like': FacebookDesktopAdLikeIcon,
  'facebook-desktop-arrow': FacebookDesktopArrowIcon,
  'facebook-desktop-follow': FacebookDesktopFollowIcon,
  'facebook-desktop-globe': FacebookDesktopGlobeIcon,
  'facebook-desktop-like': FacebookDesktopLikeIcon,
  'facebook-desktop-like-outlined': FacebookDesktopLikeOutlinedIcon,
  'facebook-desktop-message': FacebookDesktopMessageIcon,
  'facebook-desktop-message-outlined': FacebookDesktopMessageOutlinedIcon,
  'facebook-desktop-more': FacebookDesktopMoreIcon,
  'facebook-desktop-privacy-fof': FacebookDesktopPrivacyFofIcon,
  'facebook-desktop-share': FacebookDesktopShareIcon,
  'facebook-desktop-share-outlined': FacebookDesktopShareOutlinedIcon,
  'facebook-mobile-canvas-chevron-up': FacebookMobileCanvasChevronUpIcon,
  'facebook-mobile-comment': FacebookMobileCommentIcon,
  'facebook-mobile-comment-outlined': FacebookMobileCommentOutlinedIcon,
  'facebook-mobile-event-ad-rsvp': FacebookMobileEventAdRsvpIcon,
  'facebook-mobile-globe': FacebookMobileGlobeIcon,
  'facebook-mobile-like': FacebookMobileLikeIcon,
  'facebook-mobile-like-outlined': FacebookMobileLikeOutlinedIcon,
  'facebook-mobile-privacy-fof': FacebookMobilePrivacyFofIcon,
  'facebook-mobile-reel-camera': FacebookMobileReelCameraIcon,
  'facebook-mobile-reel-chevron-down': FacebookMobileReelChevronDownIcon,
  'facebook-mobile-reel-chevron-left': FacebookMobileReelChevronLeftIcon,
  'facebook-mobile-reel-location': FacebookMobileReelLocationIcon,
  'facebook-mobile-reel-search': FacebookMobileReelSearchIcon,
  'facebook-mobile-reel-sound': FacebookMobileReelSoundIcon,
  'facebook-mobile-reel-user': FacebookMobileReelUserIcon,
  'facebook-mobile-share': FacebookMobileShareIcon,
  'facebook-mobile-share-outlined': FacebookMobileShareOutlinedIcon,
  'facebook-mobile-story-chevron-up': FacebookMobileStoryChevronUpIcon,
  'facebook-mobile-story-like': FacebookMobileStoryLikeIcon,
  'facebook-mobile-story-more': FacebookMobileStoryMoreIcon,
  'facebook-mobile-story-share': FacebookMobileStoryShareIcon,
  'facebook-mobile-story-social-laugh': FacebookMobileStorySocialLaughIcon,
  'facebook-mobile-story-social-like': FacebookMobileStorySocialLikeIcon,
  'facebook-mobile-story-social-love': FacebookMobileStorySocialLoveIcon,
  'facebook-mobile-tilt-to-pan': FacebookMobileTiltToPanIcon,
  'facebook-mobile-video-ad-like': FacebookMobileVideoAdLikeIcon,
  file: FileIcon,
  'folder-directory': FolderDirectoryIcon,
  'google-desktop-chevron': GoogleDesktopChevronIcon,
  'google-desktop-date': GoogleDesktopDateIcon,
  'google-desktop-dropdown-arrow': GoogleDesktopDropdownArrowIcon,
  'google-desktop-hangout': GoogleDesktopHangoutIcon,
  'google-desktop-person': GoogleDesktopPersonIcon,
  'google-desktop-place': GoogleDesktopPlaceIcon,
  'google-desktop-play': GoogleDesktopPlayIcon,
  'google-desktop-plus': GoogleDesktopPlusIcon,
  'google-desktop-share': GoogleDesktopShareIcon,
  'google-mobile-comment': GoogleMobileCommentIcon,
  'google-mobile-event-clock': GoogleMobileEventClockIcon,
  'google-mobile-event-people': GoogleMobileEventPeopleIcon,
  'google-mobile-event-place': GoogleMobileEventPlaceIcon,
  'google-mobile-hangout': GoogleMobileHangoutIcon,
  'google-mobile-play': GoogleMobilePlayIcon,
  'google-mobile-plus': GoogleMobilePlusIcon,
  'google-mobile-share': GoogleMobileShareIcon,
  'grabber-ns': GrabberNsIcon,
  'grabber-ns-lg': GrabberNsLgIcon,
  'grabber-nsew': GrabberNsewIcon,
  'image-igtv-video-controls': ImageIgtvVideoControlsIcon,
  'image-illo': ImageIlloIcon,
  info: InfoIcon,
  'instagram-desktop-heart': InstagramDesktopHeartIcon,
  'instagram-desktop-more': InstagramDesktopMoreIcon,
  'instagram-mobile-bookmark': InstagramMobileBookmarkIcon,
  'instagram-mobile-button-chevron': InstagramMobileButtonChevronIcon,
  'instagram-mobile-camera': InstagramMobileCameraIcon,
  'instagram-mobile-camera-inverted': InstagramMobileCameraInvertedIcon,
  'instagram-mobile-chevron': InstagramMobileChevronIcon,
  'instagram-mobile-close': InstagramMobileCloseIcon,
  'instagram-mobile-comment': InstagramMobileCommentIcon,
  'instagram-mobile-cta-chevron': InstagramMobileCtaChevronIcon,
  'instagram-mobile-diagonal-arrow': InstagramMobileDiagonalArrowIcon,
  'instagram-mobile-effect': InstagramMobileEffectIcon,
  'instagram-mobile-grid': InstagramMobileGridIcon,
  'instagram-mobile-heart': InstagramMobileHeartIcon,
  'instagram-mobile-igtv-timer-bar': InstagramMobileIgtvTimerBarIcon,
  'instagram-mobile-link-arrow': InstagramMobileLinkArrowIcon,
  'instagram-mobile-list': InstagramMobileListIcon,
  'instagram-mobile-location': InstagramMobileLocationIcon,
  'instagram-mobile-more': InstagramMobileMoreIcon,
  'instagram-mobile-play': InstagramMobilePlayIcon,
  'instagram-mobile-play-inverted': InstagramMobilePlayInvertedIcon,
  'instagram-mobile-profile-igtv': InstagramMobileProfileIgtvIcon,
  'instagram-mobile-profile-posts': InstagramMobileProfilePostsIcon,
  'instagram-mobile-profile-reel': InstagramMobileProfileReelIcon,
  'instagram-mobile-profile-tagged': InstagramMobileProfileTaggedIcon,
  'instagram-mobile-send': InstagramMobileSendIcon,
  'instagram-mobile-sound': InstagramMobileSoundIcon,
  'instagram-mobile-sponsored': InstagramMobileSponsoredIcon,
  'instagram-mobile-swipe-up': InstagramMobileSwipeUpIcon,
  'instagram-mobile-swipe-up-outline': InstagramMobileSwipeUpOutlineIcon,
  'instagram-mobile-tagged': InstagramMobileTaggedIcon,
  integration: IntegrationIcon,
  jump: JumpIcon,
  label: LabelIcon,
  'label-set': LabelSetIcon,
  'layout-asset-lg': LayoutAssetLgIcon,
  'layout-cta': LayoutCtaIcon,
  'layout-cta-2': LayoutCta2Icon,
  'layout-cta-3': LayoutCta3Icon,
  'layout-day-lg': LayoutDayLgIcon,
  'layout-h1': LayoutH1Icon,
  'layout-h2': LayoutH2Icon,
  'layout-hero': LayoutHeroIcon,
  'layout-image': LayoutImageIcon,
  'layout-image-2': LayoutImage2Icon,
  'layout-image-3': LayoutImage3Icon,
  'layout-image-bottom': LayoutImageBottomIcon,
  'layout-image-left': LayoutImageLeftIcon,
  'layout-image-right': LayoutImageRightIcon,
  'layout-image-text': LayoutImageTextIcon,
  'layout-image-top': LayoutImageTopIcon,
  'layout-moment': LayoutMomentIcon,
  'layout-moment-lg': LayoutMomentLgIcon,
  'layout-month-lg': LayoutMonthLgIcon,
  'layout-section-header': LayoutSectionHeaderIcon,
  'layout-text': LayoutTextIcon,
  'layout-text-2': LayoutText2Icon,
  'layout-text-3': LayoutText3Icon,
  'layout-text-center': LayoutTextCenterIcon,
  'layout-text-image': LayoutTextImageIcon,
  'layout-text-img-lg': LayoutTextImgLgIcon,
  'layout-text-left': LayoutTextLeftIcon,
  'layout-text-right': LayoutTextRightIcon,
  'layout-week-lg': LayoutWeekLgIcon,
  lifesaver: LifesaverIcon,
  'linkedin-desktop-comment': LinkedinDesktopCommentIcon,
  'linkedin-desktop-immersive-reader': LinkedinDesktopImmersiveReaderIcon,
  'linkedin-desktop-like': LinkedinDesktopLikeIcon,
  'linkedin-desktop-save': LinkedinDesktopSaveIcon,
  'linkedin-desktop-share': LinkedinDesktopShareIcon,
  'linkedin-mobile-comment': LinkedinMobileCommentIcon,
  'linkedin-mobile-follow': LinkedinMobileFollowIcon,
  'linkedin-mobile-like': LinkedinMobileLikeIcon,
  'linkedin-mobile-share': LinkedinMobileShareIcon,
  localizations: LocalizationsIcon,
  'location-marker': LocationMarkerIcon,
  'location-marker-sm': LocationMarkerSmIcon,
  locked: LockedIcon,
  'longform-blockquote': LongformBlockquoteIcon,
  'longform-bold': LongformBoldIcon,
  'longform-h1': LongformH1Icon,
  'longform-h2': LongformH2Icon,
  'longform-h3': LongformH3Icon,
  'longform-italic': LongformItalicIcon,
  'longform-ol': LongformOlIcon,
  'longform-p': LongformPIcon,
  'longform-strikethrough': LongformStrikethroughIcon,
  'longform-text': LongformTextIcon,
  'longform-ul': LongformUlIcon,
  'longform-underline': LongformUnderlineIcon,
  minus: MinusIcon,
  'minus-solid': MinusSolidIcon,
  mobile: MobileIcon,
  moment: MomentIcon,
  'moment-cutout': MomentCutoutIcon,
  move: MoveIcon,
  note: NoteIcon,
  notifications: NotificationsIcon,
  'opal-wordmark': OpalWordmarkIcon,
  'pdf-digital': PdfDigitalIcon,
  'pdf-print': PdfPrintIcon,
  percentage: PercentageIcon,
  person: PersonIcon,
  'person-add': PersonAddIcon,
  'person-sm': PersonSmIcon,
  phone: PhoneIcon,
  'pinterest-desktop-arrow-ne': PinterestDesktopArrowNeIcon,
  'pinterest-desktop-down': PinterestDesktopDownIcon,
  'pinterest-desktop-dropdown': PinterestDesktopDropdownIcon,
  'pinterest-desktop-like': PinterestDesktopLikeIcon,
  'pinterest-desktop-more': PinterestDesktopMoreIcon,
  'pinterest-desktop-react': PinterestDesktopReactIcon,
  'pinterest-desktop-save': PinterestDesktopSaveIcon,
  'pinterest-desktop-send': PinterestDesktopSendIcon,
  'pinterest-desktop-share': PinterestDesktopShareIcon,
  'pinterest-desktop-tried-it': PinterestDesktopTriedItIcon,
  'pinterest-mobile-arrow-ne': PinterestMobileArrowNeIcon,
  'pinterest-mobile-back': PinterestMobileBackIcon,
  'pinterest-mobile-comment': PinterestMobileCommentIcon,
  'pinterest-mobile-flag-lg': PinterestMobileFlagLgIcon,
  'pinterest-mobile-like-lg': PinterestMobileLikeLgIcon,
  'pinterest-mobile-like-sm': PinterestMobileLikeSmIcon,
  'pinterest-mobile-more': PinterestMobileMoreIcon,
  'pinterest-mobile-more-sm': PinterestMobileMoreSmIcon,
  'pinterest-mobile-repin': PinterestMobileRepinIcon,
  'pinterest-mobile-repin-lg': PinterestMobileRepinLgIcon,
  'pinterest-mobile-save': PinterestMobileSaveIcon,
  'pinterest-mobile-send': PinterestMobileSendIcon,
  'pinterest-mobile-share': PinterestMobileShareIcon,
  'pinterest-tablet-back': PinterestTabletBackIcon,
  'pinterest-tablet-facebook': PinterestTabletFacebookIcon,
  'pinterest-tablet-like': PinterestTabletLikeIcon,
  'pinterest-tablet-like-lg': PinterestTabletLikeLgIcon,
  'pinterest-tablet-like-sm': PinterestTabletLikeSmIcon,
  'pinterest-tablet-more': PinterestTabletMoreIcon,
  'pinterest-tablet-pinit': PinterestTabletPinitIcon,
  'pinterest-tablet-repin': PinterestTabletRepinIcon,
  'pinterest-tablet-repin-lg': PinterestTabletRepinLgIcon,
  'pinterest-tablet-send': PinterestTabletSendIcon,
  placements: PlacementsIcon,
  play: PlayIcon,
  plus: PlusIcon,
  'plus-solid': PlusSolidIcon,
  'plus-solid-xl': PlusSolidXlIcon,
  'presentation-theme-promo': PresentationThemePromoIcon,
  preview: PreviewIcon,
  printer: PrinterIcon,
  private: PrivateIcon,
  public: PublicIcon,
  refresh: RefreshIcon,
  restore: RestoreIcon,
  'roadblock-chrome': RoadblockChromeIcon,
  'roadblock-firefox': RoadblockFirefoxIcon,
  'roadblock-ie': RoadblockIeIcon,
  'roadblock-safari': RoadblockSafariIcon,
  search: SearchIcon,
  'search-minus': SearchMinusIcon,
  'search-plus': SearchPlusIcon,
  'settings-lg': SettingsLgIcon,
  'settings-three-knobs': SettingsThreeKnobsIcon,
  'settings-two-knobs': SettingsTwoKnobsIcon,
  shape: ShapeIcon,
  share: ShareIcon,
  'sign-out': SignOutIcon,
  'sms-emoji': SmsEmojiIcon,
  'sms-more': SmsMoreIcon,
  'sms-plus': SmsPlusIcon,
  'sms-west-chevron': SmsWestChevronIcon,
  'snapchat-mobile-chevron-up': SnapchatMobileChevronUpIcon,
  'snapchat-mobile-more': SnapchatMobileMoreIcon,
  stamp: StampIcon,
  story: StoryIcon,
  'story-cutout': StoryCutoutIcon,
  tablet: TabletIcon,
  tag: TagIcon,
  'thumbnail-edit': ThumbnailEditIcon,
  'thumbnail-plus': ThumbnailPlusIcon,
  'thumbs-up': ThumbsUpIcon,
  'tiktok-desktop-chevron-east': TiktokDesktopChevronEastIcon,
  'tiktok-desktop-chevron-west': TiktokDesktopChevronWestIcon,
  'tiktok-desktop-close': TiktokDesktopCloseIcon,
  'tiktok-desktop-comment': TiktokDesktopCommentIcon,
  'tiktok-desktop-heart': TiktokDesktopHeartIcon,
  'tiktok-desktop-social-embed': TiktokDesktopSocialEmbedIcon,
  'tiktok-desktop-social-facebook': TiktokDesktopSocialFacebookIcon,
  'tiktok-desktop-social-pinterest': TiktokDesktopSocialPinterestIcon,
  'tiktok-desktop-social-twitter': TiktokDesktopSocialTwitterIcon,
  'tiktok-desktop-social-url': TiktokDesktopSocialUrlIcon,
  'tiktok-desktop-sound': TiktokDesktopSoundIcon,
  'tiktok-mobile-chevron-west': TiktokMobileChevronWestIcon,
  'tiktok-mobile-comment': TiktokMobileCommentIcon,
  'tiktok-mobile-emoji': TiktokMobileEmojiIcon,
  'tiktok-mobile-favorite': TiktokMobileFavoriteIcon,
  'tiktok-mobile-heart': TiktokMobileHeartIcon,
  'tiktok-mobile-mention': TiktokMobileMentionIcon,
  'tiktok-mobile-record': TiktokMobileRecordIcon,
  'tiktok-mobile-share': TiktokMobileShareIcon,
  'tiktok-mobile-sound': TiktokMobileSoundIcon,
  'timelines-empty': TimelinesEmptyIcon,
  'triangle-lg-e': TriangleLgEIcon,
  'triangle-lg-n': TriangleLgNIcon,
  'triangle-lg-s': TriangleLgSIcon,
  'triangle-lg-w': TriangleLgWIcon,
  'triangle-sm-e': TriangleSmEIcon,
  'triangle-sm-n': TriangleSmNIcon,
  'triangle-sm-s': TriangleSmSIcon,
  'triangle-sm-w': TriangleSmWIcon,
  'triangles-sm-ew': TrianglesSmEwIcon,
  'triangles-sm-ns': TrianglesSmNsIcon,
  'tumblr-desktop-comment': TumblrDesktopCommentIcon,
  'tumblr-desktop-like': TumblrDesktopLikeIcon,
  'tumblr-desktop-link-chevron': TumblrDesktopLinkChevronIcon,
  'tumblr-desktop-more': TumblrDesktopMoreIcon,
  'tumblr-desktop-reblog': TumblrDesktopReblogIcon,
  'tumblr-desktop-share': TumblrDesktopShareIcon,
  'tumblr-mobile-comment': TumblrMobileCommentIcon,
  'tumblr-mobile-like': TumblrMobileLikeIcon,
  'tumblr-mobile-link-chevron': TumblrMobileLinkChevronIcon,
  'tumblr-mobile-reblog': TumblrMobileReblogIcon,
  'tumblr-mobile-share': TumblrMobileShareIcon,
  'twitter-desktop-caret': TwitterDesktopCaretIcon,
  'twitter-desktop-favorite': TwitterDesktopFavoriteIcon,
  'twitter-desktop-follow': TwitterDesktopFollowIcon,
  'twitter-desktop-message': TwitterDesktopMessageIcon,
  'twitter-desktop-more': TwitterDesktopMoreIcon,
  'twitter-desktop-profile-calendar': TwitterDesktopProfileCalendarIcon,
  'twitter-desktop-profile-clock': TwitterDesktopProfileClockIcon,
  'twitter-desktop-profile-gear': TwitterDesktopProfileGearIcon,
  'twitter-desktop-profile-location': TwitterDesktopProfileLocationIcon,
  'twitter-desktop-profile-more': TwitterDesktopProfileMoreIcon,
  'twitter-desktop-profile-url': TwitterDesktopProfileUrlIcon,
  'twitter-desktop-profile-verified': TwitterDesktopProfileVerifiedIcon,
  'twitter-desktop-reply': TwitterDesktopReplyIcon,
  'twitter-desktop-retweet': TwitterDesktopRetweetIcon,
  'twitter-desktop-single-favorite': TwitterDesktopSingleFavoriteIcon,
  'twitter-desktop-single-follow': TwitterDesktopSingleFollowIcon,
  'twitter-desktop-single-gear': TwitterDesktopSingleGearIcon,
  'twitter-desktop-single-reply': TwitterDesktopSingleReplyIcon,
  'twitter-desktop-single-retweet': TwitterDesktopSingleRetweetIcon,
  'twitter-desktop-single-share': TwitterDesktopSingleShareIcon,
  'twitter-desktop-stream-card': TwitterDesktopStreamCardIcon,
  'twitter-desktop-stream-card-sm': TwitterDesktopStreamCardSmIcon,
  'twitter-desktop-stream-favorite': TwitterDesktopStreamFavoriteIcon,
  'twitter-desktop-stream-reply': TwitterDesktopStreamReplyIcon,
  'twitter-desktop-stream-retweet': TwitterDesktopStreamRetweetIcon,
  'twitter-desktop-stream-share': TwitterDesktopStreamShareIcon,
  'twitter-desktop-website-card-url': TwitterDesktopWebsiteCardUrlIcon,
  'twitter-mobile-app-rating': TwitterMobileAppRatingIcon,
  'twitter-mobile-card-yellow': TwitterMobileCardYellowIcon,
  'twitter-mobile-caret': TwitterMobileCaretIcon,
  'twitter-mobile-profile-calendar': TwitterMobileProfileCalendarIcon,
  'twitter-mobile-profile-location': TwitterMobileProfileLocationIcon,
  'twitter-mobile-profile-url': TwitterMobileProfileUrlIcon,
  'twitter-mobile-single-favorite': TwitterMobileSingleFavoriteIcon,
  'twitter-mobile-single-message': TwitterMobileSingleMessageIcon,
  'twitter-mobile-single-more': TwitterMobileSingleMoreIcon,
  'twitter-mobile-single-reply': TwitterMobileSingleReplyIcon,
  'twitter-mobile-single-retweet': TwitterMobileSingleRetweetIcon,
  'twitter-mobile-single-share': TwitterMobileSingleShareIcon,
  'twitter-mobile-stream-favorite': TwitterMobileStreamFavoriteIcon,
  'twitter-mobile-stream-follow': TwitterMobileStreamFollowIcon,
  'twitter-mobile-stream-follow-sm': TwitterMobileStreamFollowSmIcon,
  'twitter-mobile-stream-message': TwitterMobileStreamMessageIcon,
  'twitter-mobile-stream-reply': TwitterMobileStreamReplyIcon,
  'twitter-mobile-stream-retweet': TwitterMobileStreamRetweetIcon,
  'twitter-mobile-stream-share': TwitterMobileStreamShareIcon,
  unlocked: UnlockedIcon,
  'unlocked-left': UnlockedLeftIcon,
  upload: UploadIcon,
  'upload-cloud': UploadCloudIcon,
  'upload-cloud-lg': UploadCloudLgIcon,
  url: UrlIcon,
  'url-add': UrlAddIcon,
  'video-camera': VideoCameraIcon,
  'view-column': ViewColumnIcon,
  'view-grid': ViewGridIcon,
  'view-list': ViewListIcon,
  'view-mosaic': ViewMosaicIcon,
  'view-seamless': ViewSeamlessIcon,
  'view-tiles': ViewTilesIcon,
  'vine-desktop-follow': VineDesktopFollowIcon,
  'vine-desktop-more': VineDesktopMoreIcon,
  'vine-mobile-comment': VineMobileCommentIcon,
  'vine-mobile-like': VineMobileLikeIcon,
  'vine-mobile-location': VineMobileLocationIcon,
  'vine-mobile-more': VineMobileMoreIcon,
  'vine-mobile-revine': VineMobileRevineIcon,
  'vk-desktop-heart': VkDesktopHeartIcon,
  'vk-desktop-more': VkDesktopMoreIcon,
  'vk-desktop-reply': VkDesktopReplyIcon,
  'vk-desktop-share': VkDesktopShareIcon,
  'vk-desktop-views': VkDesktopViewsIcon,
  'vk-mobile-heart': VkMobileHeartIcon,
  'vk-mobile-more': VkMobileMoreIcon,
  'vk-mobile-reply': VkMobileReplyIcon,
  'vk-mobile-share': VkMobileShareIcon,
  'vk-mobile-views': VkMobileViewsIcon,
  warning: WarningIcon,
  'warning-sm': WarningSmIcon,
  'weibo-desktop-chevron': WeiboDesktopChevronIcon,
  'weibo-desktop-collapse': WeiboDesktopCollapseIcon,
  'weibo-desktop-like': WeiboDesktopLikeIcon,
  'weibo-desktop-link': WeiboDesktopLinkIcon,
  'weibo-mobile-comment': WeiboMobileCommentIcon,
  'weibo-mobile-follow-plus': WeiboMobileFollowPlusIcon,
  'weibo-mobile-like': WeiboMobileLikeIcon,
  'weibo-mobile-link': WeiboMobileLinkIcon,
  'weibo-mobile-share': WeiboMobileShareIcon,
  workflow: WorkflowIcon,
  'youtube-desktop-add-to-playlist': YoutubeDesktopAddToPlaylistIcon,
  'youtube-desktop-like': YoutubeDesktopLikeIcon,
  'youtube-desktop-more': YoutubeDesktopMoreIcon,
  'youtube-desktop-share': YoutubeDesktopShareIcon,
  'youtube-desktop-short-comment': YoutubeDesktopShortCommentIcon,
  'youtube-desktop-short-dislike': YoutubeDesktopShortDislikeIcon,
  'youtube-desktop-short-like': YoutubeDesktopShortLikeIcon,
  'youtube-desktop-short-more': YoutubeDesktopShortMoreIcon,
  'youtube-desktop-short-share': YoutubeDesktopShortShareIcon,
  'youtube-desktop-short-sound': YoutubeDesktopShortSoundIcon,
  'youtube-desktop-subscribe': YoutubeDesktopSubscribeIcon,
  'youtube-mobile-collapse': YoutubeMobileCollapseIcon,
  'youtube-mobile-dislike': YoutubeMobileDislikeIcon,
  'youtube-mobile-like': YoutubeMobileLikeIcon,
  'youtube-mobile-short-chevron-east': YoutubeMobileShortChevronEastIcon,
  'youtube-mobile-short-comment': YoutubeMobileShortCommentIcon,
  'youtube-mobile-short-dislike': YoutubeMobileShortDislikeIcon,
  'youtube-mobile-short-like': YoutubeMobileShortLikeIcon,
  'youtube-mobile-short-note': YoutubeMobileShortNoteIcon,
  'youtube-mobile-short-promotion': YoutubeMobileShortPromotionIcon,
  'youtube-mobile-short-remix': YoutubeMobileShortRemixIcon,
  'youtube-mobile-short-share': YoutubeMobileShortShareIcon,
  'youtube-mobile-short-sound': YoutubeMobileShortSoundIcon,
} as const
export const gem = {
  'gem-add': GemAddIcon,
  'gem-add-checkbox': GemAddCheckboxIcon,
  'gem-add-circle-filled': GemAddCircleFilledIcon,
  'gem-add-link': GemAddLinkIcon,
  'gem-add-small': GemAddSmallIcon,
  'gem-add-table': GemAddTableIcon,
  'gem-ai': GemAiIcon,
  'gem-ai-white': GemAiWhiteIcon,
  'gem-ai-white-sparkle': GemAiWhiteSparkleIcon,
  'gem-airplane': GemAirplaneIcon,
  'gem-align-center': GemAlignCenterIcon,
  'gem-align-justified': GemAlignJustifiedIcon,
  'gem-align-left': GemAlignLeftIcon,
  'gem-align-right': GemAlignRightIcon,
  'gem-archive': GemArchiveIcon,
  'gem-arrow-ns': GemArrowNsIcon,
  'gem-assignments': GemAssignmentsIcon,
  'gem-bell': GemBellIcon,
  'gem-bell-fill': GemBellFillIcon,
  'gem-bell-hidden': GemBellHiddenIcon,
  'gem-block-filled-dark': GemBlockFilledDarkIcon,
  'gem-block-filled-light': GemBlockFilledLightIcon,
  'gem-block-outlined': GemBlockOutlinedIcon,
  'gem-bold': GemBoldIcon,
  'gem-books': GemBooksIcon,
  'gem-bullet-list': GemBulletListIcon,
  'gem-calculator': GemCalculatorIcon,
  'gem-calendar': GemCalendarIcon,
  'gem-calendar-today': GemCalendarTodayIcon,
  'gem-card': GemCardIcon,
  'gem-cascade': GemCascadeIcon,
  'gem-channel-all': GemChannelAllIcon,
  'gem-channel-all-filled': GemChannelAllFilledIcon,
  'gem-channel-audio': GemChannelAudioIcon,
  'gem-channel-audio-filled': GemChannelAudioFilledIcon,
  'gem-channel-blog': GemChannelBlogIcon,
  'gem-channel-blog-filled': GemChannelBlogFilledIcon,
  'gem-channel-bluesky': GemChannelBlueskyIcon,
  'gem-channel-bluesky-filled': GemChannelBlueskyFilledIcon,
  'gem-channel-calendar': GemChannelCalendarIcon,
  'gem-channel-calendar-filled': GemChannelCalendarFilledIcon,
  'gem-channel-digital-ad': GemChannelDigitalAdIcon,
  'gem-channel-digital-ad-filled': GemChannelDigitalAdFilledIcon,
  'gem-channel-display-ad': GemChannelDisplayAdIcon,
  'gem-channel-display-ad-filled': GemChannelDisplayAdFilledIcon,
  'gem-channel-email': GemChannelEmailIcon,
  'gem-channel-email-filled': GemChannelEmailFilledIcon,
  'gem-channel-facebook': GemChannelFacebookIcon,
  'gem-channel-facebook-filled': GemChannelFacebookFilledIcon,
  'gem-channel-flickr': GemChannelFlickrIcon,
  'gem-channel-flickr-filled': GemChannelFlickrFilledIcon,
  'gem-channel-foursquare': GemChannelFoursquareIcon,
  'gem-channel-foursquare-filled': GemChannelFoursquareFilledIcon,
  'gem-channel-googleplus': GemChannelGoogleplusIcon,
  'gem-channel-googleplus-filled': GemChannelGoogleplusFilledIcon,
  'gem-channel-instagram': GemChannelInstagramIcon,
  'gem-channel-instagram-filled': GemChannelInstagramFilledIcon,
  'gem-channel-linkedin': GemChannelLinkedinIcon,
  'gem-channel-linkedin-filled': GemChannelLinkedinFilledIcon,
  'gem-channel-list': GemChannelListIcon,
  'gem-channel-list-filled': GemChannelListFilledIcon,
  'gem-channel-mail': GemChannelMailIcon,
  'gem-channel-mail-filled': GemChannelMailFilledIcon,
  'gem-channel-message': GemChannelMessageIcon,
  'gem-channel-message-filled': GemChannelMessageFilledIcon,
  'gem-channel-more': GemChannelMoreIcon,
  'gem-channel-more-filled': GemChannelMoreFilledIcon,
  'gem-channel-photo': GemChannelPhotoIcon,
  'gem-channel-photo-filled': GemChannelPhotoFilledIcon,
  'gem-channel-pinterest': GemChannelPinterestIcon,
  'gem-channel-pinterest-filled': GemChannelPinterestFilledIcon,
  'gem-channel-print': GemChannelPrintIcon,
  'gem-channel-print-filled': GemChannelPrintFilledIcon,
  'gem-channel-reddit': GemChannelRedditIcon,
  'gem-channel-reddit-filled': GemChannelRedditFilledIcon,
  'gem-channel-sms': GemChannelSmsIcon,
  'gem-channel-snapchat': GemChannelSnapchatIcon,
  'gem-channel-snapchat-filled': GemChannelSnapchatFilledIcon,
  'gem-channel-star': GemChannelStarIcon,
  'gem-channel-star-filled': GemChannelStarFilledIcon,
  'gem-channel-threads': GemChannelThreadsIcon,
  'gem-channel-threads-filled': GemChannelThreadsFilledIcon,
  'gem-channel-tiktok': GemChannelTiktokIcon,
  'gem-channel-tiktok-filled': GemChannelTiktokFilledIcon,
  'gem-channel-tumblr': GemChannelTumblrIcon,
  'gem-channel-tumblr-filled': GemChannelTumblrFilledIcon,
  'gem-channel-twitter': GemChannelTwitterIcon,
  'gem-channel-twitter-filled': GemChannelTwitterFilledIcon,
  'gem-channel-video': GemChannelVideoIcon,
  'gem-channel-video-filled': GemChannelVideoFilledIcon,
  'gem-channel-vimeo': GemChannelVimeoIcon,
  'gem-channel-vimeo-filled': GemChannelVimeoFilledIcon,
  'gem-channel-vine': GemChannelVineIcon,
  'gem-channel-vine-filled': GemChannelVineFilledIcon,
  'gem-channel-vk': GemChannelVkIcon,
  'gem-channel-vk-filled': GemChannelVkFilledIcon,
  'gem-channel-web-filled': GemChannelWebFilledIcon,
  'gem-channel-web-module-filled': GemChannelWebModuleFilledIcon,
  'gem-channel-web-modules': GemChannelWebModulesIcon,
  'gem-channel-website': GemChannelWebsiteIcon,
  'gem-channel-weibo': GemChannelWeiboIcon,
  'gem-channel-weibo-filled': GemChannelWeiboFilledIcon,
  'gem-channel-wordpress': GemChannelWordpressIcon,
  'gem-channel-wordpress-filled': GemChannelWordpressFilledIcon,
  'gem-channel-youtube': GemChannelYoutubeIcon,
  'gem-channel-youtube-filled': GemChannelYoutubeFilledIcon,
  'gem-chat': GemChatIcon,
  'gem-check': GemCheckIcon,
  'gem-check-circle': GemCheckCircleIcon,
  'gem-check-circle-filled': GemCheckCircleFilledIcon,
  'gem-check-dashed-circle': GemCheckDashedCircleIcon,
  'gem-check-dashed-circle-filled': GemCheckDashedCircleFilledIcon,
  'gem-check-delivery': GemCheckDeliveryIcon,
  'gem-check-delivery-filled': GemCheckDeliveryFilledIcon,
  'gem-chevron-e': GemChevronEIcon,
  'gem-chevron-n': GemChevronNIcon,
  'gem-chevron-s': GemChevronSIcon,
  'gem-chevron-w': GemChevronWIcon,
  'gem-circle': GemCircleIcon,
  'gem-circle-delivery': GemCircleDeliveryIcon,
  'gem-circle-delivery-filled': GemCircleDeliveryFilledIcon,
  'gem-clock': GemClockIcon,
  'gem-close': GemCloseIcon,
  'gem-close-circle': GemCloseCircleIcon,
  'gem-close-circle-filled': GemCloseCircleFilledIcon,
  'gem-close-delivery': GemCloseDeliveryIcon,
  'gem-close-delivery-filled': GemCloseDeliveryFilledIcon,
  'gem-close-small': GemCloseSmallIcon,
  'gem-cloud': GemCloudIcon,
  'gem-cog': GemCogIcon,
  'gem-columns': GemColumnsIcon,
  'gem-comment': GemCommentIcon,
  'gem-condensed-mode': GemCondensedModeIcon,
  'gem-connection': GemConnectionIcon,
  'gem-content-filled-dark': GemContentFilledDarkIcon,
  'gem-content-filled-light': GemContentFilledLightIcon,
  'gem-content-outlined': GemContentOutlinedIcon,
  'gem-content-queue': GemContentQueueIcon,
  'gem-copy': GemCopyIcon,
  'gem-dash-circle': GemDashCircleIcon,
  'gem-dash-circle-filled': GemDashCircleFilledIcon,
  'gem-dash-delivery': GemDashDeliveryIcon,
  'gem-dash-delivery-filled': GemDashDeliveryFilledIcon,
  'gem-delivery': GemDeliveryIcon,
  'gem-download': GemDownloadIcon,
  'gem-download-cloud': GemDownloadCloudIcon,
  'gem-edit': GemEditIcon,
  'gem-empty-image': GemEmptyImageIllustration,
  'gem-error-circle': GemErrorCircleIcon,
  'gem-eye': GemEyeIcon,
  'gem-eye-hidden': GemEyeHiddenIcon,
  'gem-file': GemFileIcon,
  'gem-filter': GemFilterIcon,
  'gem-full-mode': GemFullModeIcon,
  'gem-full-screen': GemFullScreenIcon,
  'gem-globe': GemGlobeIcon,
  'gem-graph': GemGraphIcon,
  'gem-grid': GemGridIcon,
  'gem-h1': GemH1Icon,
  'gem-h2': GemH2Icon,
  'gem-h3': GemH3Icon,
  'gem-h4': GemH4Icon,
  'gem-hamburger-menu': GemHamburgerMenuIcon,
  'gem-highlight': GemHighlightIcon,
  'gem-image': GemImageIcon,
  'gem-image-add': GemImageAddIcon,
  'gem-indent': GemIndentIcon,
  'gem-info-circle': GemInfoCircleIcon,
  'gem-info-circle-filled': GemInfoCircleFilledIcon,
  'gem-italic': GemItalicIcon,
  'gem-journal': GemJournalIcon,
  'gem-label': GemLabelIcon,
  'gem-label-set': GemLabelSetIcon,
  'gem-lifesaver': GemLifesaverIcon,
  'gem-link': GemLinkIcon,
  'gem-location': GemLocationIcon,
  'gem-locked': GemLockedIcon,
  'gem-minus': GemMinusIcon,
  'gem-minus-circle-filled': GemMinusCircleFilledIcon,
  'gem-moment-filled-dark': GemMomentFilledDarkIcon,
  'gem-moment-filled-light': GemMomentFilledLightIcon,
  'gem-moment-outlined': GemMomentOutlinedIcon,
  'gem-moments': GemMomentsIcon,
  'gem-more-horizontal': GemMoreHorizontalIcon,
  'gem-more-vertical': GemMoreVerticalIcon,
  'gem-mosaic': GemMosaicIcon,
  'gem-multiple-choice': GemMultipleChoiceIcon,
  'gem-no-highlight': GemNoHighlightIcon,
  'gem-no-search-result': GemNoSearchResultIllustration,
  'gem-no-text-color': GemNoTextColorIcon,
  'gem-note': GemNoteIcon,
  'gem-numbered-list': GemNumberedListIcon,
  'gem-opal-logo': GemOpalLogoIcon,
  'gem-opal-wordmark': GemOpalWordmarkIcon,
  'gem-opal-wordmark-pride': GemOpalWordmarkPrideIcon,
  'gem-paragraph': GemParagraphIcon,
  'gem-pause-circle': GemPauseCircleIcon,
  'gem-pause-circle-filled': GemPauseCircleFilledIcon,
  'gem-phone': GemPhoneIcon,
  'gem-photo-attachment': GemPhotoAttachmentIcon,
  'gem-piechart': GemPiechartIcon,
  'gem-plan-builder': GemPlanBuilderIllustration,
  'gem-plans': GemPlansIcon,
  'gem-play': GemPlayIcon,
  'gem-popout': GemPopoutIcon,
  'gem-presentations': GemPresentationsIcon,
  'gem-question-mark': GemQuestionMarkIcon,
  'gem-quote': GemQuoteIcon,
  'gem-reddit': GemRedditIcon,
  'gem-reddit-14': GemReddit14Icon,
  'gem-reddit-comment': GemRedditCommentIcon,
  'gem-reddit-downvote': GemRedditDownvoteIcon,
  'gem-reddit-share': GemRedditShareIcon,
  'gem-reddit-upvote': GemRedditUpvoteIcon,
  'gem-return': GemReturnIcon,
  'gem-rows-stacked': GemRowsStackedIcon,
  'gem-search': GemSearchIcon,
  'gem-settings': GemSettingsIcon,
  'gem-share': GemShareIcon,
  'gem-sidebar-left': GemSidebarLeftIcon,
  'gem-sidebar-right': GemSidebarRightIcon,
  'gem-single-choice': GemSingleChoiceIcon,
  'gem-sort-ascending': GemSortAscendingIcon,
  'gem-sort-descending': GemSortDescendingIcon,
  'gem-sort-unsorted': GemSortUnsortedIcon,
  'gem-sparkle': GemSparkleIcon,
  'gem-sparkle-filled': GemSparkleFilledIcon,
  'gem-speech-bubble-question-mark': GemSpeechBubbleQuestionMarkIcon,
  'gem-stamp': GemStampIcon,
  'gem-star-fill': GemStarFillIcon,
  'gem-star-outline': GemStarOutlineIcon,
  'gem-status': GemStatusIcon,
  'gem-stories': GemStoriesIcon,
  'gem-story-filled-dark': GemStoryFilledDarkIcon,
  'gem-story-filled-light': GemStoryFilledLightIcon,
  'gem-story-outlined': GemStoryOutlinedIcon,
  'gem-strikethrough': GemStrikethroughIcon,
  'gem-submit': GemSubmitIcon,
  'gem-subscript': GemSubscriptIcon,
  'gem-superscript': GemSuperscriptIcon,
  'gem-swimlane': GemSwimlaneIcon,
  'gem-swimlane-group': GemSwimlaneGroupIcon,
  'gem-tasks': GemTasksIcon,
  'gem-text': GemTextIcon,
  'gem-text-color': GemTextColorIcon,
  'gem-thumbs-down': GemThumbsDownIcon,
  'gem-thumbs-down-circle': GemThumbsDownCircleIcon,
  'gem-thumbs-down-circle-filled': GemThumbsDownCircleFilledIcon,
  'gem-thumbs-up': GemThumbsUpIcon,
  'gem-thumbs-up-circle': GemThumbsUpCircleIcon,
  'gem-thumbs-up-circle-filled': GemThumbsUpCircleFilledIcon,
  'gem-thumbs-up-dashed-circle': GemThumbsUpDashedCircleIcon,
  'gem-thumbs-up-dashed-circle-filled': GemThumbsUpDashedCircleFilledIcon,
  'gem-timelines': GemTimelinesIcon,
  'gem-toggle': GemToggleIcon,
  'gem-trash': GemTrashIcon,
  'gem-two-thumbs-up': GemTwoThumbsUpIcon,
  'gem-type': GemTypeIcon,
  'gem-underline': GemUnderlineIcon,
  'gem-unlocked': GemUnlockedIcon,
  'gem-upload': GemUploadIcon,
  'gem-upload-cloud': GemUploadCloudIcon,
  'gem-upload-file-attachment': GemUploadFileAttachmentIcon,
  'gem-user': GemUserIcon,
  'gem-users': GemUsersIcon,
  'gem-version-history': GemVersionHistoryIcon,
  'gem-view': GemViewIcon,
  'gem-warning': GemWarningIcon,
  'gem-warning-delivery': GemWarningDeliveryIcon,
  'gem-warning-delivery-filled': GemWarningDeliveryFilledIcon,
  'gem-warning-filled': GemWarningFilledIcon,
  'gem-workflow': GemWorkflowIcon,
  'gem-workspace': GemWorkspaceIcon,
} as const
